export const common = [
  {
    contentid: '3006542',
    contenttypeid: '76',
    title: 'Seonyudo Park (선유도공원)',
    createdtime: '20230904135239',
    modifiedtime: '20230905190507',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/template/sub/seonyudo.do" target="_blank">parks.seoul.go.kr/template/sub/seonyudo.do</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/01/2678801_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/01/2678801_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '20',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '343 , Seonyu-ro, Yeongdeungpo-gu, Seoul',
    addr2: '',
    zipcode: '07200',
    mapx: '126.9024425270',
    mapy: '37.5422918129',
    mlevel: '6',
    overview:
      "Seonyudo Park is Korea's first water-themed ecological park. The park was renewed from an old water treatment plant. Visitors can observe a water purification system, an aquatic plant garden, and an ecological forest, as well as exhibitions and other interesting facilities. The park also hosts diverse hands-on programs and exhibitions.&nbsp;"
  },
  {
    contentid: '3006358',
    contenttypeid: '76',
    title: 'Seoul Botanic Park (서울식물원)',
    createdtime: '20230904095240',
    modifiedtime: '20230905195747',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://botanicpark.seoul.go.kr/" target="_blank">botanicpark.seoul.go.kr/</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/60/2658460_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/60/2658460_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '4',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010700',
    addr1: '161 , Magokdong-ro, Gangseo-gu, Seoul',
    addr2: '',
    zipcode: '07789',
    mapx: '126.8360144928',
    mapy: '37.5692236076',
    mlevel: '6',
    overview:
      'The Seoul Botanical Garden was created in Magok, the last remaining development site in Seoul, to introduce native plants and horticulture of 12 different cities from around the world and raise ecological awareness in the city. Seoul Botanic Park integrates a botanical garden and a public park, and the area is the size of 70 soccer fields. It serves as a bridgehead and lifelong education institution with the aim of spreading urban garden culture while staying true to its original role as a plant research conservation institution through expanding endangered wild plant habitats, researching the proliferation of species, and developing varieties. The botanical garden is divided into four spaces: Open Forest, Themed Garden, Lake Garden, and Wetland Garden. The main highlight is the Themed Garden that comprises the Botanic Center, Mogok Cultural Hall, and an outdoor themed garden.&nbsp;'
  },
  {
    contentid: '897540',
    contenttypeid: '76',
    title: 'Cheonggyecheon Stream (청계천)',
    createdtime: '20091215020805',
    modifiedtime: '20230828104402',
    tel: '+82-2-2290-7111',
    telname: '',
    homepage:
      '<a href="http://www.sisul.or.kr/open_content/cheonggye/" target="_blank" title="새창: 청계천 ">www.sisul.or.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: 'Changsin-dong, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04563',
    mapx: '127.0050907302',
    mapy: '37.5697015781',
    mlevel: '6',
    overview:
      "Cheonggyecheon Stream starts from Cheonggye Plaza, just off Sejong-ro Avenue. Cheonggye Plaza roughly covers an area of 2,500 square meters and is located at the starting point of Cheonggyecheon Stream. The square, created based on the design of traditional Korean <em>bojagi</em> (a colorful wrapping cloth), features the elegant beauty of traditional stonework that is colorful yet refined. The plaza also includes a model of Cheonggyecheon that provides visitors with a bird's-eye view of the restored Cheonggyecheon Stream. At the plaza, there are plaques that provide detailed commentaries on the 22 bridges that span the stream, as well as a number of graceful fountains that add to the ambiance of the area. The area commemorates the Cheonggyecheon Stream Restoration Project, and also symbolizes gathering, harmony, peace, and unity.<br /><br />After the completion of Cheonggye Plaza, the Seoul Metropolitan Government designated the area as a vehicle-free zone on holidays, providing more leisure space for pedestrians. Since then, the waterfront areas of Cheonggyecheon Stream, and the surrounding streets have become popular places for those seeking refreshment and a variety of cultural experiences. A favorite of many is the Candle Fountain, which features the magnificent synchronicity of three different lighting fixtures and a four-meter-high, two-tiered waterfall. Along the two sides of the waterfall are the Palseokdam wishing wells, made of eight different stones from each of the nation's eight provinces."
  },
  {
    contentid: '1340416',
    contenttypeid: '76',
    title: 'Culture Station Seoul 284 (문화역 서울 284)',
    createdtime: '20110725204226',
    modifiedtime: '20230811101848',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://www.seoul284.org" target="_blank" title="문화역서울284 사이트로 이동">www.seoul284.org</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/32/1985332_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/32/1985332_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '1, Tongil-ro, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04509',
    mapx: '126.9716025029',
    mapy: '37.5560136788',
    mlevel: '6',
    overview:
      'Culture Station Seoul 284 opened in 2011 by restoring the old Seoul Station. The complex holds various programs including exhibitions, performances, cultural events and workshops. It holds over 100 years of history with Namdaemun Station being the original name of the station in 1900 and changing to Gyeongseong Station, Seoul Station, and now Culture Station Seoul 284. The look of 1925 Gyeongseong Station offers visitors a flashback to the past, providing a fun and special experience.'
  },
  {
    contentid: '264351',
    contenttypeid: '76',
    title:
      'Jongmyo Shrine [UNESCO World Heritage] (종묘 [유네스코 세계문화유산])',
    createdtime: '20090929190340',
    modifiedtime: '20230828095755',
    tel: '+82-2-765-0195',
    telname: '',
    homepage:
      '<a href="http://tour.jongno.go.kr/" target="_blank" class="web">tour.jongno.go.kr</a> <br>\n<a href="http://jm.cha.go.kr" target="_blank" class="web">www.cha.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/41/2678541_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/41/2678541_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '157, Jong-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03135',
    mapx: '126.9948998937',
    mapy: '37.5731898785',
    mlevel: '6',
    overview:
      'Jongmyo Shrine was the primary place of worship for kings and their queens throughout the Joseon dynasty. The compound is composed of various buildings in addition to the main hall. The shrine was built at the same time as Gyeongbokgung Palace, under the orders of King Taejo, the first king of the Joseon dynasty. The shrine is the site of the royal memorial service, called Jongmyo Jaerye, a national event that has been passed down since the Three Kingdoms period. The shrine was designated as a UNESCO World Cultural Heritage site on December 9, 1995, for its well-preserved ancient customs, such as memorial services and traditional music, which are designated National Intangible Cultural Asset. <br /><br />During the Joseon dynasty, the ritual was held on the first month of a seasonal change and the twelfth month of the lunar year, but was stopped during the Japanese colonial period. Now, it is annually reenacted on the first Sunday of May. Jongmyo Jaeryeak, the musical part of the ceremony, is produced by instruments, songs, and dances that originated over 500 years ago.'
  },
  {
    contentid: '1326972',
    contenttypeid: '76',
    title: 'Hongdae (Hongik University Street) (홍대)',
    createdtime: '20110708001349',
    modifiedtime: '20230811113830',
    tel: '',
    telname: '',
    homepage:
      '<a href="https://www.mapo.go.kr/site/culture/content/culture010204" target="_blank">www.mapo.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '13',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '20, Hongik-ro, Mapo-gu, Seoul',
    addr2: '',
    zipcode: '04055',
    mapx: '126.9227542239',
    mapy: '37.5543713280',
    mlevel: '6',
    overview:
      'Hongdae is a neighborhood known for its youthful ambience, with shops selling everything from clothing and cosmetics to living goods and books, as well as unique cafés and restaurants. The streets are also filled with buskers and dance performances, making a walk here quite entertaining. Special streets such as ateliers’ street (lined with private institutions for art students preparing for university entrance exams), Picasso’s Street, and Club Street are also must-go places for anyone hoping to fully experience the Hongdae area.'
  },
  {
    contentid: '264337',
    contenttypeid: '76',
    title: 'Gyeongbokgung Palace (경복궁)',
    createdtime: '20110226022850',
    modifiedtime: '20230706161327',
    tel: '+82-2-3700-3900',
    telname: '',
    homepage:
      '<a href="http://www.royalpalace.go.kr/" target="_blank">www.royalpalace.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010100',
    addr1: '161, Sajik-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03045',
    mapx: '126.9769930325',
    mapy: '37.5788222356',
    mlevel: '6',
    overview:
      'Built in 1395, Gyeongbokgung Palace is commonly referred to as the Northern Palace because its location is furthest north when compared to the neighboring palaces of Changdeokgung (Eastern Palace) and Gyeonghuigung (Western Palace). Gyeongbokgung Palace is arguably the most beautiful, and remains the largest of all five palaces. <br /><br />The premises were once destroyed by fire during the Imjin War (1592-1598). However, all of the palace buildings were later restored under the leadership of Heungseondaewongun during the reign of King Gojong (1852-1919). <br /><br />Remarkably, the most representative edifices of the Joseon dynasty, Gyeonghoeru Pavilion and the pond around Hyangwonjeong Pavilion have remained relatively intact. The raised dias and stone markers of Geunjeongjeon showcase the representative art style of their time.<br /><br />The National Palace Museum of Korea is located outside of Heungnyemun Gate, and the National Folk Museum is located on the eastern side of Hyangwonjeong Pavillion.'
  },
  {
    contentid: '264550',
    contenttypeid: '76',
    title: 'Namsan Seoul Tower (남산서울타워)',
    createdtime: '20110224200326',
    modifiedtime: '20230614105042',
    tel: '+82-2-3455-9277',
    telname: '',
    homepage:
      '<a href="http://www.seoultower.co.kr/" target="_blank" class="web">www.seoultower.co.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '21',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050600',
    addr1: '105, Namsangongwon-gil, Yongsan-gu, Seoul',
    addr2: '0',
    zipcode: '04340',
    mapx: '126.9878983791',
    mapy: '37.5511089858',
    mlevel: '6',
    overview:
      "Namsan Seoul Tower was the first multipurpose tower to be established in Korea, effectively incorporating a sightseeing observatory to a broadcasting tower. For the past 40 years, Namsan Seoul Tower has served as an iconic landmark of Korea and a representative tourist attraction. The tower's observatory offers an unobstructed view of the whole city, allowing it to become one of the all-time favorite attractions of Seoul citizens as well as domestic and international tourists. Another highlight of the tower is the Namsan Cable Car. The cable car began its operation in 1962, transferring passengers from the foot of the mountain to the base of the tower. Shuttle buses to the Namsan Cable Car from downtown Seoul are also available for visitors' convenience."
  },
  {
    contentid: '264340',
    contenttypeid: '76',
    title: 'Yeouido Park (여의도공원)',
    createdtime: '20030109181517',
    modifiedtime: '20230324135930',
    tel: '+82-2-761-4079',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/" target="_blank">parks.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/31/1954531_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/31/1954531_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '20',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '68, Yeouigongwon-ro, Yeongdeungpo-gu, Seoul',
    addr2: '',
    zipcode: '07243',
    mapx: '126.9202635904',
    mapy: '37.5257801616',
    mlevel: '6',
    overview:
      'Yeouido Park is a large recreational area located on Yeouido Island in the central part of Seoul. It was once originally covered with black asphalt, and people frequented the place for bicycling and roller-skating. The construction began in 1997 and opened officially in February 1999. It is now the place where many people in the city come to rest and enjoy strolling around, playing sports, and cultural events.'
  },
  {
    contentid: '264315',
    contenttypeid: '76',
    title: 'Heunginjimun Gate - Dongdaemun Gate (흥인지문)',
    createdtime: '20030109040219',
    modifiedtime: '20230323135028',
    tel: '+82-2-2148-1842',
    telname: '',
    homepage:
      '<a href="http://tour.jongno.go.kr" target="_blank"class="web">tour.jongno.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/36/1568436_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/36/1568436_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010300',
    addr1: '288, Jong-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03119',
    mapx: '127.0095263952',
    mapy: '37.5711931512',
    mlevel: '6',
    overview:
      'Heunginjimun Gate was built to protect Hanseongbu, which historically housed essential government facilities. Heunginjimun Gate was the gate on the east side of the outer wall of Seoul Fortress among eight gates. It is referred to as Dongdaemun Gate as well. The gate was constructed during King Taejo&rsquo;s 5th year in 1396, remodeled during the reign of King Danjong in 1453, and was newly built in 1869 during the sixth year of King Gojong&rsquo;s reign in 1869. <br /><br />The gate features a hipped roof with five front and two side compartments on a two-storied building. The thin and weak bracket system supports the eaves and is excessively decorated, reflecting the construction features of the late Joseon period. Also, outside of the fortress is the half-circle-shaped Ongseong, a small wall, to protect the gate. <br /><br />One of the unique factors of Heunginjimun Gate is that it is the only gate among Seoul&rsquo;s eight to have Ongseong, further exhibiting the style of construction used during the late Joseon period.'
  },
  {
    contentid: '264134',
    contenttypeid: '76',
    title: 'Cheong Wa Dae (Blue House) (청와대)',
    createdtime: '20030103195138',
    modifiedtime: '20230307143236',
    tel: '+82-2-1330',
    telname: '',
    homepage:
      '<a href="https://www.opencheongwadae.kr/"target="_blank">www.opencheongwadae.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/23/774323_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/23/774323_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050600',
    addr1: '1, Cheongwadae-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03048',
    mapx: '126.9746792089',
    mapy: '37.5839799278',
    mlevel: '6',
    overview:
      "The signature markings of the Presidential Residence of Cheong Wa Dae are its blue tiles on the Main Office; it is the first thing to catch one's attention upon viewing the premises. Approximately 150 thousand tiles compose the roof of the Main Office. Each tile was baked individually to make them strong enough to last for hundreds of years. The blue tiles and the smoothly curving roofline blend beautifully with Bugaksan Mountain in the backdrop. <br /><br />Cheong Wa Dae is comprised of the Main Office, Yeongbingwan (State Guest House), Chunchugwan (Spring and Autumn) Hall, Nokjiwon Garden, Mugunghwa (Rose of Sharon) Hill, and Chilgung Palace. It is interesting to see that all the buildings are unique and beautifully designed, built in the traditional Korean style. Just outside the premises is Cheongwadae Sarangchae, an exhibition hall showing the history of Cheong Wa Dae and the Korean presidency, as well as gifts received by heads of State over the years. The hall is open and free to all visitors."
  },
  {
    contentid: '264257',
    contenttypeid: '76',
    title: 'Sungnyemun Gate (숭례문)',
    createdtime: '20030109032423',
    modifiedtime: '20230223111206',
    tel: '+82-2-779-8547',
    telname: '',
    homepage:
      '<a href="http://www.junggu.seoul.kr/tour/" target="_blank" class="web">www.junggu.seoul.kr</a><br><a href="http://www.heritage.go.kr/heri/cul/culSelectDetail.do?ccbaCpno=1111100010000&pageNo=1_1_1_1" target="_blank" class="web">www.heritage.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/01/1945801_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/01/1945801_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010300',
    addr1: '40, Sejong-daero, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04528',
    mapx: '126.9752992762',
    mapy: '37.5599855058',
    mlevel: '6',
    overview:
      'Sungnyemun Gate is Korea&rsquo;s National Treasure No. 1, and its unofficial name is Namdaemun Gate. Sungnyemun Gate is the largest castle gate stone structure with an arched entrance in the middle. There&rsquo;s a column on top of a platform, raising the roof, distinguishing the upper stories and lower stories of the building. Passageways for traffic are located at the east and west ends of the gate. Different from the other gates, Sungnyemun Gate&rsquo;s tablet has its name written vertically. <br /><br />On February 10, 2008, Sungnyemun was destroyed by fire. After a 5-year reconstruction work, the gate was re-opened to the public again on May 4, 2013.'
  },
  {
    contentid: '264116',
    contenttypeid: '76',
    title: 'Namsangol Hanok Village (남산골한옥마을)',
    createdtime: '20021227011750',
    modifiedtime: '20230217083829',
    tel: '+82-2-2261-0500',
    telname: '',
    homepage:
      '<a href="http://hanokmaeul.or.kr/" target="_blank" class="web">hanokmaeul.or.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010600',
    addr1: '28, Toegye-ro 34-gil, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04626',
    mapx: '126.9940059289',
    mapy: '37.5591248302',
    mlevel: '6',
    overview:
      "Namsangol Hanok Village opened in 1998 on the northern side of Namsan Mountain in the center of the capital. This village has five restored hanok (traditional Korean house) premises, a pavilion, a traditional garden, a performance art stage, and a time capsule plaza, making it a perfect spot for locals and tourists to take a leisure walk. Upon entering from the front gate, visitors will get a taste of Korea's traditional life while escaping from bustling city life. The traditional garden with its pavilion and old houses creates a peaceful ambiance before the forested Namsan Mountain. A time capsule commemorating Seoul&rsquo;s 600th anniversary was buried in 1994 at the highest point of the village and is scheduled to be reopened 400 years later in 2394. <br /><br />The five hanok premises at Namsangol Hanok Village once belonged to aristocrats and government officials of the Joseon dynasty. Each house was originally located in a different neighborhood, but they were all moved to this area and restored to their original form. The houses were rebuilt using their original materials, except for one house, where the materials were too old and deteriorated to be reused. The premises were carefully restored and replicated according to their original form to depict the owners&rsquo; social class and personality. These buildings are now used as an exhibit to portray the living environment during the Joseon dynasty and as a venue for educational and cultural programs for children and tourists.<br /><br />Some of the unique programs and activities to participate in include wearing hanbok, folding hanji (traditional Korean paper), writing in Korean, traditional tea ceremony, traditional etiquette school, and herbal medicine experience. There are also taekwondo demonstrations and other various performances held around the village. Visitors can also try traditional games such as <em>yunnori</em> (traditional board game), or understand more about the area through a guided tour."
  },
  {
    contentid: '2946681',
    contenttypeid: '76',
    title: 'Seongsu-dong Cafe Street (성수동 카페거리)',
    createdtime: '20221207144255',
    modifiedtime: '20230201093456',
    tel: '',
    telname: '',
    homepage:
      '<a href="https://www.sd.go.kr/tour/index.do" target="_blank">www.sd.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '16',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030600',
    addr1: 'Seongsu-dong, Seongdong-gu, Seoul',
    addr2: '',
    zipcode: '04795',
    mapx: '127.0566145649',
    mapy: '37.5432527996',
    mlevel: '6',
    overview:
      'Yeonmujang-gil in Seongsu-dong, known for old factories and a shoe workshop street, has been reborn as a place of trendy cafes and culture. The energy of car repair shops, printing factories, and handmade shoes street still exist today but, as global restaurant brands, select shops, and cafes have set up amidst busily operating factories, an atmosphere unique to Seongsu-dong has been created. "Daerim Warehouse" led to the change in the Seongsu-dong streets and can be said to be the originator of all warehouse-style cafes that are popular throughout Cafe Street today. The red-brick structure, antique signboards, and a vast indoor space of an old warehouse have been maintained and, with the addition of a sensuous interior design, it has become a space suitable for fashion shows and exhibits, thus showing new potential for old Seongsu-dong architecture. Every day, new cafes, bakeries, restaurants, and cultural complexes open their doors and are busy welcoming visitors.'
  },
  {
    contentid: '2944158',
    contenttypeid: '76',
    title: 'Gyeongnidan Street (경리단길)',
    createdtime: '20221207143240',
    modifiedtime: '20230118161318',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://www.yongsan.go.kr" target="_blank">www.yongsan.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '21',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: 'Itaewon-dong, Yongsan-gu, Seoul',
    addr2: '',
    zipcode: '04343',
    mapx: '126.9875154390',
    mapy: '37.5384521160',
    mlevel: '6',
    overview:
      "Gyeongnidan Street refers to the 937-meter-long road from the main gate of MND Financial Management Corps to Grand Hyatt Seoul as well as all of the nearby streets and alleys. It is called Gyeongnidan Street because the Korean army's central finance corps, or Gyeongnidan in Korean, used to be located here, and has gained fame for presenting a different vibe than that of Itaewon despite being part of Itaewon-dong. Gyeongnidan Street is an area of culture and youth where people are able to enjoy diverse and special cuisine and dishes at unique restaurants and cafes. Although it resembles a typical neighborhood of Seoul, it features foreigners who have come from many different places around the globe living in natural harmony with Korean locals, which exudes a unique, exotic atmosphere. It is fun to walk along the various streets and alleys to discover novel and sophisticated shops."
  },
  {
    contentid: '264152',
    contenttypeid: '76',
    title: 'Lotte World (롯데월드)',
    createdtime: '20030104231833',
    modifiedtime: '20230119100857',
    tel: '+82-1661-2000',
    telname: 'Lotte World',
    homepage:
      '<a href="http://www.lotteworld.com/" target="_blank">www.lotteworld.com</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '18',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020600',
    addr1: '240, Olympic-ro, Songpa-gu, Seoul',
    addr2: '',
    zipcode: '05554',
    mapx: '127.0979006014',
    mapy: '37.5113516917',
    mlevel: '6',
    overview:
      "Operated by Lotte Group, Lotte World is the perfect spot for entertainment and sightseeing for Koreans and international tourists alike. The theme park is divided into the indoor Lotte World Adventure, and the outdoor lakeside Magic Island, with additional amenities including a shopping mall, folk museum, ice rink, hotel, and more. <br><br>\n\nLotte World Adventure is the world's largest indoor amusement park, complete with top-of-the-line rides, fantastic parades and performances, and food from around the world. The Folk Museum displays miniature models of Korea throughout 5,000 years in history. Lotte World Garden Stage presents various themed musicals to match each season and Lotte World Star Avenue is the perfect place to experience Korean stars and the entertainment world."
  },
  {
    contentid: '2003918',
    contenttypeid: '76',
    title: 'Lotte World Tower & Mall (롯데월드타워&롯데월드몰)',
    createdtime: '20150519223248',
    modifiedtime: '20230117102244',
    tel: '+82-2-3213-5000',
    telname: '',
    homepage:
      '<a href="http://www.lwt.co.kr" target="_blank">www.lwt.co.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '18',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050600',
    addr1: '300, Olympic-ro, Songpa-gu, Seoul',
    addr2: '',
    zipcode: '05551',
    mapx: '127.1025918048',
    mapy: '37.5126349603',
    mlevel: '6',
    overview:
      "Lotte World Tower was designed with a conceptual motif inspired by Korean ceramics and writing brushes. With 123 floors total, the tower is the fifth tallest building in the world, standing at 555 meters. The tower contains galleries, cafés, and a luxury hotel, in addition to a skywalk and an observation deck. It is one of the best spots to appreciate the breathtaking view of Seoul's vibrant city lights.<br>\n<br> Lotte World Mall, located next to the tower, features Avenuel, a complex of luxury department stores. The multi-leveled mall draws in many visitors as one of the top shopping attractions in Seoul, with a variety of domestic and foreign brands. The mall also offers a wide-range of entertainment facilities, such as a movie theater, aquarium, concert hall, and more."
  },
  {
    contentid: '2944084',
    contenttypeid: '76',
    title: 'Haneul Park (하늘공원)',
    createdtime: '20221207141112',
    modifiedtime: '20230117110212',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/"target="_blank">parks.seoul.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '13',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '95, Haneulgongwon-ro, Mapo-gu, Seoul',
    addr2: '',
    zipcode: '03900',
    mapx: '126.8863599027',
    mapy: '37.5691522918',
    mlevel: '6',
    overview:
      'Haneul Park is part of the World Cup Park and one of the five parks near the World Cup Stadium together with Peace Park, Nanjicheon Park, Nanji Hangang Park, and Noeul Park. It was established for the purpose of restoring the ecological environment so operates its facilities by using natural energy. It features a silver grass field, a mixed grassland, a rock garden, a sunflower field, an observatory rest area, and a wind power generator. Among the various parts of the World Cup Park, it is located the closest to the sky and shows the transformation from a barren landfill restored to nature. In fall, silver grass forms a spectacle, and, here, visitors can get a clear, panoramic view of Seoul including Bukhansan Mountain and the Hangang River. It is also known as a place for beautiful sunsets and nightscapes.'
  },
  {
    contentid: '1348713',
    contenttypeid: '76',
    title: 'April 19th National Cemetery (국립4.19민주묘지)',
    createdtime: '20110803005924',
    modifiedtime: '20230102143552',
    tel: '+82-2-996-0419',
    telname: '',
    homepage:
      '<a href="http://419.mpva.go.kr/"target="_blank" title="새창: 국립4.19민주묘지">419.mpva.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/50/2025950_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/50/2025950_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '3',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '17, 4.19-ro 8-gil, Gangbuk-gu, Seoul',
    addr2: '',
    zipcode: '01009',
    mapx: '127.0091159038',
    mapy: '37.6484480504',
    mlevel: '6',
    overview:
      'Located at the foot of Bukhansan Mountain, the April 19th National Cemetery was established in memory of the 224 people who lost their lives during the 4.19 Revolution in 1960. The cemetery features a memorial hall and a traditional wooden structure that houses the grave of the historic figure Yu Yeongbong. <br /><br />At the cemetery is a pond surrounded by sculptures such as "Symbolic Door," "Roots of Democracy," and "Sparks of Justice" and a memorial tower bearing an inscription for the brave patriots who lost their lives during the revolution. Groves of pine, juniper, yew, and maple trees and the well-kept hiking path add a natural charm to the overwhelming ambiance of peace and serenity. Many people visit to see the spring blossoms in May, and throughout the year to take in the glorious scene of the sunset over Bukhansan Mountain.'
  },
  {
    contentid: '264358',
    contenttypeid: '76',
    title: 'Itaewon Special Tourist Zone (이태원 관광특구)',
    createdtime: '20030109182459',
    modifiedtime: '20230117155831',
    tel: '+82-2-797-7319',
    telname: '',
    homepage:
      '<a href ="http://www.itaewon.or.kr/" target ="blank"class="web">www.itaewon.or.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '21',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020200',
    addr1: '196, Itaewon-ro, Yongsan-gu, Seoul',
    addr2: '',
    zipcode: '04405',
    mapx: '126.9958259074',
    mapy: '37.5343944032',
    mlevel: '6',
    overview:
      'Itaewon was the first special tourist zone in Seoul, designated in 1997. It is a multicultural place where over 20,000 foreigners live and is widely recognized by international visitors. <br /><br />The name Itaewon started to spread worldwide in the 1980s when Korea hosted the 1986 Seoul Asian Games and the 1988 Seoul Olympic Games, as well as many international conferences. Since then, Itaewon has become a popular travel destination. Clothes and accessories with unique designs, and leather products in particular are famous. This is a go-to place for both shopping and entertainment. The street is crowded with shops selling clothes and bags, as well as hotels, restaurants, entertainment facilities and travel agencies. With about 2,000 shops and stores lining every street, visitors can experience a multicultural atmosphere. Also famous in the district is Antique Furniture Street where more than 100 shops selling furniture and antiques stretch from Hamilton Hotel toward Bogwang-ro. <br /><br />Travelers can taste authentic cuisine and experience culture from around the globe on World Food Street where there are 40 restaurants operated by foreigners. Since the late 1990s, an increase in the number of tourists from Southeast Asia and the Middle East has transformed the streets from being US Army-oriented into culturally diverse. Various performances and events are held in the area. In particular, Itaewon Global Village Festival, held every October, is a famous festival. Tourists can pay in US dollars, Japanese yen, or another currency freely. In addition, visitors can use various languages like English, Japanese, and Chinese with the sellers.'
  },
  {
    contentid: '2943972',
    contenttypeid: '76',
    title: 'Ikseon-dong (익선동)',
    createdtime: '20221207135824',
    modifiedtime: '20230116134454',
    tel: '',
    telname: '',
    homepage:
      '<a href="https://www.korean.visitseoul.net" target="_blank">www.korean.visitseoul.net</a><br/><a href="http://www.tour.jongno.go.kr"target="_blank">www.tour.jongno.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: 'Ikseon-dong, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03133',
    mapx: '126.9897920161',
    mapy: '37.5735203041',
    mlevel: '6',
    overview:
      'Ikseon-dong is a place where the harmony of alleys and hanok houses exudes beautiful charm and is a must-visit spot for tourists of all ages and genders. It is also an area that connects the younger and older generations.'
  },
  {
    contentid: '264138',
    contenttypeid: '76',
    title: 'Myeongdong Cathedral (서울 명동성당)',
    createdtime: '20030103200938',
    modifiedtime: '20221227094028',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://www.mdsd.or.kr/" target="_blank" title="새창  :명동대성당 홈페이지로 이동">www.mdsd.or.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/03/1987703_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/03/1987703_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010900',
    addr1: '74, Myeongdong-gil, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04537',
    mapx: '126.9872814233',
    mapy: '37.5633131117',
    mlevel: '6',
    overview:
      'Myeongdong Cathedral is the Church for Archdiocese of Seoul and was also the birthplace for the Roman Catholic Church community in Korea. The church houses the remains of several individuals: Bishop Laurent Joseph Marie Imbert (1796-1839), and priests Peter Simon (1803-1839), James (Jacques Honor Chastan, 1803-1839) and Pourthie Jean Antoine Charles (1830-1866) and four martyrs. <br /><br />Myeongdong Cathedral is located in downtown Seoul and tourists frequently come and visit the place. Near the cathedral are other tourism spots such as Namsangol Hanok Village preserving Korean traditional houses, N Seoul Tower overlooking Seoul and Namdaemun Market, a traditional market with a wide variety of food and goods.'
  },
  {
    contentid: '1909500',
    contenttypeid: '76',
    title: 'Bugak Skyway Palgakjeong Pavilion (북악스카이 팔각정)',
    createdtime: '20140331192146',
    modifiedtime: '20221226143601',
    tel: '+82-2-725-6602',
    telname: '',
    homepage:
      '<a title="새창 : 북악팔각정 사이트로 이동" href="https://bit.ly/3yEXe8p" target="_blank">tour.jongno.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/32/2667332_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/32/2667332_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '267, Bugaksan-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03010',
    mapx: '126.9805670485',
    mapy: '37.6020279352',
    mlevel: '6',
    overview:
      "Bugak Skyway Palgakjeong Pavilion exudes a tranquil, serene beauty regardless of the season. The pavilion, which sits on Bugaksan's 1,652,900 square meter summit at an altitude of 345 meters, was built in a traditional Korean-style and became a popular attraction within the city. There are also spaces for visitors to enjoy food and drinks."
  },
  {
    contentid: '1349202',
    contenttypeid: '76',
    title: "Maeheon Citizen's Forest (매헌시민의 숲)",
    createdtime: '20110803222138',
    modifiedtime: '20221221091741',
    tel: '+82-2-575-3895',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/" target="_blank">parks.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/66/2668466_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/66/2668466_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '15',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010400',
    addr1: '99, Maeheon-ro, Seocho-gu, Seoul',
    addr2: '',
    zipcode: '06773',
    mapx: '127.0369572316',
    mapy: '37.4730383770',
    mlevel: '6',
    overview:
      "Maeheon Citizen's Forest, located near Yangjae Tollgate, was created in anticipation of the Seoul Asian Games in 1986 and the 24th Olympic Games in 1988. The forest provides a scenic habitat for 94,800 trees of 43 different species including pine, zelkova, purple bloom maple, horse chestnut, and nut pine. These trees are rarely seen in cities and the park is a popular date spot for couples. In the fall, the trees in the park bear an abundance of persimmons and quinces. <br /><br />Amenities and facilities include an outdoor wedding hall, walking course, basketball court, volleyball court (also used for foot volleyball), tennis court, barefoot walking path, and outdoor workout equipment. Memorial sites and monuments like the memorial of Patriot Yun Bong-Gil can also be found scattered throughout the park grounds."
  },
  {
    contentid: '1542646',
    contenttypeid: '76',
    title: 'Songpa Naru Park (Seokchonhosu Lake) (송파나루공원 (석촌호수))',
    createdtime: '20120121012732',
    modifiedtime: '20221216163918',
    tel: '+82-2-2147-3385',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/parks/detailView.do?pIdx=118&tabTarget=1" target="_blank" title="서울의 공원 사이트로 이동">parks.seoul.go.kr</a><br><a href="https://www.songpa.go.kr/culture/detailInfo.do?resrceCd=TR0147-1000053&sc1=TR0147&rcpp=6&key=3822" target="_blank" title="송파 문화관광 사이트로 이동">www.songpa.go.kr/culture</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '18',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '136, Samhaksa-ro, Songpa-gu, Seoul',
    addr2: '',
    zipcode: '05608',
    mapx: '127.0979728676',
    mapy: '37.5095713442',
    mlevel: '6',
    overview:
      'Songpa Naru Park, also commonly referred to as Seokchonhosu Lake, is a citizen park in Seoul with a jogging course and walking trails. It has two lakes with Songpa-daero Boulevard running in between. Originally, a branch of the Hangang River ran through the site, forming one large lake, but the lake was divided into two with the construction of Songpa-daero Boulevard. The total size of the two lakes is 217,850 ㎡, and they hold about 737 tons of water. The depth of the lakes is 4-5 meters.'
  },
  {
    contentid: '789703',
    contenttypeid: '76',
    title: 'Olympic Park (올림픽공원)',
    createdtime: '20090828204759',
    modifiedtime: '20221216162731',
    tel: '+82-2-410-1114',
    telname: '',
    homepage:
      '<a href="http://www.olympicpark.co.kr/" target="_blank" class="Web">www.olympicpark.co.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '18',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '424, Olympic-ro, Songpa-gu, Seoul',
    addr2: '',
    zipcode: '05540',
    mapx: '127.1224425827',
    mapy: '37.5194456386',
    mlevel: '6',
    overview:
      'Olympic Park is an impressive leisure facility in which historic remains from the Baekje era share space with modern, state-of-the-art sports stadiums, an eco-friendly forest, and spacious grass fields. The legacy of the 1988 Seoul Olympics, the park not only houses the country’s largest sports arena, but has also become a place where Seoul residents come to relax and unwind. \n<br><br>\nSpread across approximately 1.45 million square meters, Olympic Park encompasses the land that was once Mongchontoseong Fortress and Mongchonhaeja (manmade lake) from the early Baekje period. The park is divided into several zones, including a leisure sports park, a cultural art park, an eco-park, and the History Experience Park dedicated to the area’s rich historic heritage. \n<br><br>\nBecause Olympic Park is so large and takes over three hours to explore, visitors are advised to familiarize themselves with entrances and exits and travel routes before they start. To further save time, visitors can ride the Road Train (“Hodori Train”) located next to Peace Square.'
  },
  {
    contentid: '789696',
    contenttypeid: '76',
    title: 'Seoul Forest (서울숲)',
    createdtime: '20090828195906',
    modifiedtime: '20221216160517',
    tel: '+82-2-460-2905',
    telname: '',
    homepage:
      '<a class="Web" href="http://seoulforest.or.kr/" target="_blank">seoulforest.or.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '16',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010500',
    addr1: '273, Ttukseom-ro, Seongdong-gu, Seoul',
    addr2: '',
    zipcode: '04770',
    mapx: '127.0417770333',
    mapy: '37.5430553337',
    mlevel: '6',
    overview:
      'Opened on June 18, 2005, Seoul Forest had previously undergone a series of changes on Ttukseom Island. In the past, the forest had been a royal hunting ground for kings and served as a military inspection facility. However, in more recent decades, the area has served a wide variety of functions. Ttukseom initially served as a water treatment facility, and later as a golf course, horse racing track, and eventually a sports park. <br>\n<br>\n Consisting of five parks spread over approximately 595,000 ㎡ of land, Seoul Forest is an eco-friendly zone appreciated not only by the people of the city but also those visiting Seoul. Seoul Forest is rapidly developing into the premium city-park of Korea like Hyde Park in London and Central Park in New York. <br>\n<br>\n * Culture & Art Park<br>\n Situated in the heart of Seoul Forest, Culture & Art Park features Seoul Forest Plaza, decorative flower beds, Visitor Center, a skate park, outdoor stage, waterside lounge (restaurant), in-forest open space, in-forest play ground and water play area. <br>\n<br>\n * Eco Forest <br>\n The Eco Forest, once an area covered by the Hangang River, has been transformed into an eco-forest connecting the Hangang River and Jungnangcheon Stream. This natural habitat for wildlife is home to fallow deer, formosan deer, elk, chipmunks, mandarin ducks, mallards, spot-billed ducks and moorhens. There is also an observatory to help visitors get a better view of the local wildlife. <br>\n<br>\n * Experiential Learning Park<br>\n Occupying the structure of the former Ttukseom Water Treatment Facility, this refurbished educational area was established to house an insect botanical garden, wild flower garden, themed flower garden, event ground and surrounding protective forest. <br>\n<br>\n * Marsh Plants Garden<br>\n Making use of the local reservoir’s natural environment, the Wetlands Ecological Field contains a wetlands ecological management office, ecological playground, outdoor nature classroom, bird observatory, wetlands flower garden and botanical garden fed with local, clear waters. <br>\n<br>\n * Hangang Riverside Park <br> Located southwest of Seoul Forest, this riverside area at the junction of the Hangang River and Jungnangcheon Stream features a waterfront park, marina and rest area.'
  },
  {
    contentid: '1751094',
    contenttypeid: '76',
    title: 'Namsan Outdoor Botanical Garden (남산 야외식물원)',
    createdtime: '20121113182946',
    modifiedtime: '20221216091223',
    tel: '+82-2-798-3771',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr" target="_blank" title="New window popup" class="web">parks.seoul.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '21',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010700',
    addr1: '323, Sowol-ro, Yongsan-gu, Seoul',
    addr2: '',
    zipcode: '04340',
    mapx: '126.9969033844',
    mapy: '37.5415658115',
    mlevel: '6',
    overview:
      'Namsan Outdoor Botanical Garden opened its doors on February 18, 1997 in Hannam-dong, where the residential complex for foreigners once stood before it was demolished in 1994. Covering an area of around 59 ㎡, it is divided into 13 themed gardens with a total 117,132 plants from 269 species. Among this diversity, 60,912 plants from 129 species are tree types and 56,220 plants from 140 species are grass types.'
  },
  {
    contentid: '1323377',
    contenttypeid: '76',
    title: 'Sinsa-dong Garosu-gil Road (신사동 가로수길)',
    createdtime: '20110704192531',
    modifiedtime: '20221216135645',
    tel: '+82-2-3445-0111',
    telname: '',
    homepage:
      '<a href="https://korean.visitseoul.net/shopping/%EC%8B%A0%EC%82%AC%EB%8F%99-%EA%B0%80%EB%A1%9C%EC%88%98%EA%B8%B8_/291" target="_blank" title="새창: 비짓 서울">korean.visitseoul.net</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '1',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030600',
    addr1: 'Sinsa-dong, Gangnam-gu, Seoul',
    addr2: '',
    zipcode: '06028',
    mapx: '127.0227543748',
    mapy: '37.5215324916',
    mlevel: '6',
    overview:
      "The ginkgo tree-lined street (Sinsa-dong Garosu-gil) that runs from Sinsa Station (Subway Line 3) to Hyeondae High School is a popular, upscale street in Seoul. The street (also known as ‘artists' street’) has an eccentric flair thanks to its variety of charmingly decorated coffee shops, and designer stores. Garosu-gil is particularly popular in autumn when the golden ginkgo leaves begin to fall. Furthermore, with continous popularity, it has become one of the most attractive film locations in the city."
  },
  {
    contentid: '264454',
    contenttypeid: '76',
    title: 'World Cup Park (월드컵공원)',
    createdtime: '20040202223441',
    modifiedtime: '20221215111835',
    tel: '+82-2-120',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/template/sub/worldcuppark.do" target="blank" class="web">parks.seoul.go.kr</a> (Korean only)',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '13',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '243-60, World Cup-ro, Mapo-gu, Seoul',
    addr2: '',
    zipcode: '03900',
    mapx: '126.8824101471',
    mapy: '37.5732600775',
    mlevel: '6',
    overview:
      "Opened on May 1st, 2002, the Wolrd Cup Park was once a 15-year-old landfill that held over 92 million tons of garbage. The park is located near Seoul World Cup Stadium, and is made up of five smaller parks - <em>Pyeonghwa</em> (Peace) Park, <em>Haneul</em> (Sky) Park, <em>Noeul</em> (Sunset) Park, Nanjicheon Park, and Nanji Hangang Park.\n\n<br /><br>\n\n\n * Pyeonghwa Park: Closest to Seoul World Cup Stadium, it holds a pond, garden, children’s playground, and forest. As a representative park of World Cup Park, the park was designed in hopes of peace and harmony between mankind and nature. It is often used as a picnic area and place for nature studies. \n\n<br><br />\n\n\n * Nanji Hangang Park: Nanji Hangang Park was developed on the banks of the Hangang River. In contrast to other Hangang River parks, Nanji Hangang Park is a water-friendly park that has a gradual slope towards the riverbank. The park consists of a camping ground, soccer field, basketball court, grass field, cruise ship port, and an area for nature studies.\n<br><br>\n\n\n * Haneul Park: Haneul Park consists of vast grassland located at the highest elevation of the five parks. The park's pasture is covered with eulalias and wild flowers in their most natural state. In addition, 30,000 butterflies of different species were introduced in 2000 to stabilize the ecosystem. Five wind-powered generators provide power to the park and the park’s maintenance office. Once a mountain of garbage, it is now a green hill with 22 lookout points offering breathtaking views of Seoul, including the N Seoul Tower, Bukhansan Mountain, and Hangang River. Tall trees are line the park to provide shades and serve as resting spots for visitors. As a popular spot to enjoy the sight of eulalias, the park usually remains open until late in the evening during the Eulalia Festival period.\n\n<br><br />\n\n * Noeul Park: In order to prevent the vast area of land of what was once a wasteland from becoming an unnecessary chunk of land, a nine-hole golf course was constructed in what is now known as Noeul Park. The golf course serves as an environment friendly entertainment park to visitors while stabilizing the geographical formation and has an urban park nearby that offers scenic views of the Hangang River and beautiful sunset. Located west of the golf park is Noeul Square, decorated with shrubs and flowers. \n\n<br><br />\n\n\n * Nanjicheon Park: Nanjicheon Park was developed from the Nanji Stream, which flowed under Haneul Park. It was once overflowing with sewage runoff from a nearby landfill, but it has since been beautifully restored into a park with clear water. The park is built to serve as a recreational spot for those with for youths, elders, and people with disabilities."
  },
  {
    contentid: '264348',
    contenttypeid: '76',
    title:
      'Changdeokgung Palace Complex [UNESCO World Heritage] (창덕궁과 후원 [유네스코 세계문화유산])',
    createdtime: '20090929200743',
    modifiedtime: '20221214162949',
    tel: '+82-2-3668-2300',
    telname: '',
    homepage:
      '<a href="http://www.cdg.go.kr/" target="_blank" class="web">www.cdg.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010100',
    addr1: '99, Yulgok-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03072',
    mapx: '126.9919888278',
    mapy: '37.5809583673',
    mlevel: '6',
    overview:
      'Changdeokgung Palace was the second royal villa built following the construction of Gyeongbokgung Palace in 1405. It was the principal palace for many kings of the Joseon dynasty, and is the most well-preserved of the five remaining royal Joseon palaces. The palace grounds are comprised of a public palace area, a royal family residence building, and the rear garden. Known as a place of rest for the kings, the rear garden boasts a gigantic tree that is over 300 years old, a small pond and a pavilion. <br>\n<br>\n The palace gained importance starting from the time of Seongjong, the 9th king of Joseon, when a number of kings began using it as a place of residence. Unfortunately, the palace was burned down by angry citizens in 1592 when the royal family fled their abode during the Imjin War. Thanks to Gwanghaegun, the palace was restored in 1611. Even today, it houses a number of cultural treasures, such as Injeongjeon Hall, Daejojeon Hall, Seonjeongjeon Hall, and Nakseonjae Hall. <br>\n<br>\n Changdeokgung Palace’s garden behind the inner hall, called the Secret Garden, was constructed during the reign of King Taejong and served as a rest area for the royal family members. The garden had formerly been called Bugwon and Geumwon, but was renamed Biwon Garden, or Secret Garden, after King Gojong came into power. The garden was kept as natural as possible and was touched by human hands only when absolutely necessary. Buyongjeong Pavilion, Buyongji Pond, Juhamnu Pavilion, Eosumun Gate, Yeonghwadang Hall, Bullomun Gate, Aeryeonjeong Pavilion, and Yeongyeongdang Hall are some of the many attractions that occupy the garden. The most beautiful time to see the garden is during the fall when the autumn foliage is at its peak and the leaves have just started to fall. <br>\n<br>\n Though it has been treasured by Koreans for centuries, Changdeokgung Palace was  recognized as a World Cultural Heritage site by the UNESCO World Cultural Heritage Committee in December of 1997 during the committee meeting in Naples, Italy.'
  },
  {
    contentid: '1748004',
    contenttypeid: '76',
    title: 'Seodaemun Independence Park (서대문독립공원)',
    createdtime: '20121106012625',
    modifiedtime: '20221215093338',
    tel: '+82-2-3140-8305',
    telname: '',
    homepage: '',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '14',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '251, Tongil-ro, Seodaemun-gu, Seoul',
    addr2: '',
    zipcode: '03732',
    mapx: '126.9556450402',
    mapy: '37.5766554381',
    mlevel: '6',
    overview:
      'Seodaemun Independence Park was built on the former Seoul Detention Camp. It was used to imprison thousands of Korean independence activists until the liberation from the Japanese occupation on August 15, 1945, as well as the political prisoners during the political turmoil in the 1960s. When the prison was moved to Uiwang-si, Gyeonggi-do in November 1987, the area was restored and turned into a memorial park in August 15, 1992  to honor the sacrifices of the martyrs. The park preserves seven prison buildings, an execution ground, underground women’s prison, and the March 1st Movement Monument that has been moved from Tapgol Park in Jongno.<br><br>\nOne of the most significant monuments of the Seodaemun Independence Park is Dongnimmun Gate (Independence Gate), which has been designated a Historic Site. Nearby is Dongnipgwan (Independence Hall), originally called Mohwagwan, which was used to greet Chinese envoys during the Joseon dynasty. Today, the hall enshrines 2,327 tablets inscribed with the names of Koreans who died for the cause of national independence. Standing right next to Dongnimmun Gate are the remnants of Yeongeunmun Gate, another Historic Site. Other sights inside the park include the Patriotic Martyr Monument, Declaration of Independence Monument, and Statue of Dr. Seo Jae-pil, who was an independence activist and publisher of Korea’s first independent newspaper. The main highlight of the park is the Seodaemun Prison History Hall, a former prison building that was renovated into a history museum.'
  },
  {
    contentid: '264354',
    contenttypeid: '76',
    title: 'Insa-dong (인사동)',
    createdtime: '20110226021013',
    modifiedtime: '20221214161331',
    tel: '+82-2-734-0222',
    telname: '',
    homepage:
      '<a href="http://www.insainfo.or.kr/" target="_blank"class="web">www.insainfo.or.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '62, Insadong-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03146',
    mapx: '126.9833758804',
    mapy: '37.5754310780',
    mlevel: '6',
    overview:
      'Insa-dong, located in the heart of the city, is an important place where old but precious traditional goods are on display. There is one main road in Insa-dong with alleys on each side. Within these alleys are galleries, traditional restaurants, teahouses, and cafes. <br>\n<br>\nThe galleries are the heartbeat of Insa-dong. There are about 100 galleries in the area offering every example of traditional Korean fine art from paintings to sculptures. The most famous galleries are Hakgojae Gallery, which functions as the center of folk art, Gana Art Gallery, which promotes many promising artists, and Gana Art Center. <br>\n<br>\nThe teahouses and restaurants are the perfect complement to the galleries. They are hidden deep within the twisting alleyways, making it feel like a treasure hunt. The shops in Insa-dong are very popular among all age groups, because each one is unique. <br>\n<br>\n Every Saturday from 14:00 to 22:00 and Sunday from 10:00 to 22:00, the main street is blocked to vehicular traffic and it becomes a cultural space. Stores set up booths outside and Korean candy merchants and fortune teller stalls can easily be found; there are traditional performances and exhibits as well. Insa-dong is especially popular among international tourists. This is where they can experience and see traditional Korean culture first-hand, and also purchase pieces of fine art.'
  },
  {
    contentid: '264329',
    contenttypeid: '76',
    title: 'Gwanghwamun Gate (광화문)',
    createdtime: '20030109181214',
    modifiedtime: '20221214145540',
    tel: '+82-2-3700-3900',
    telname: '',
    homepage:
      '<a href="http://www.royalpalace.go.kr/" target="_blank" class="web">www.royalpalace.go.kr</a> (Korean, English)',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010300',
    addr1: '161, Sajik-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03045',
    mapx: '126.9768042386',
    mapy: '37.5760725520',
    mlevel: '6',
    overview:
      "Built in 1395 under the reign of King Taejo, the first king of the Joseon dynasty, Gwanghwamun Gate is the southern gate of Gyeongbokgung Palace. It is also the main gate of the palace, therefore larger and fancier in comparison to the other gates. Gwanghwamun Gate consists of three arched gates; the center gate was used by the king, while the other two were used by the crown prince and royal officials. The tall granite walls of the gate serve as a platform for the wooden gate tower that watches over the city. The gate has a sign with its name written at the top center of the gate tower. <br>\n<br> Gwanghwamun Gate went through several damages and restorations over the course of history. It was first severely damaged during the Imjin War (1592-1598) and was not restored until the reconstruction of Gyeongbokgung Palace in 1864. Under the Japanese administration, the gate was demolished and relocated to the north of the palace's eastern gate, followed by series of damages during the Korean War (1950-1953). In 1968, Gwanghwamun Gate was relocated back to the south of the palace and was rebuilt using concrete; however, the gate’s position was shifted a few meters away from its original location. In 2006, a major reconstruction project took place to restore Gwanghwamun Gate to its original state and location, disassembling the structure completely and replacing concrete with granite and wood. After three years and eight months of construction, Gwanghwamun Gate was fully restored to its original form and was open to the public on August 15, 2010."
  },
  {
    contentid: '264316',
    contenttypeid: '76',
    title: 'Deoksugung Palace (덕수궁)',
    createdtime: '20030109040234',
    modifiedtime: '20221214100806',
    tel: '+82-2-771-9951',
    telname: '',
    homepage:
      '<a href="http://www.deoksugung.go.kr/" target="_blank" class="web">www.deoksugung.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010100',
    addr1: '99, Sejong-daero, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04519',
    mapx: '126.9749296905',
    mapy: '37.5661486714',
    mlevel: '6',
    overview:
      "Registered as Historic Site No. 124, Deoksugung Palace was initially not a royal palace, but a residential home of Grand Prince Wolsan (1454-1488), the older brother of King Seongjong (1469-1494) of the Joseon dynasty. It wasn't until 1593 that the palace was used as a temporary palace of the royal family after their home was burned down during the Imjin War. King Seonjo also stayed at Deoksugung Palace after returning to the city. It became a proper palace when Gwanghaegun (1575-1641) ascended to the throne and gave this royal residence the name Gyeongungung Palace in 1611. Over the following decades, the palace alternated between being an official palace and a temporary residence. The name did not change officially to Deoksugung Palace, meaning the “palace of virtuous longevity,” until 1907. While the palace once encompassed a vast area with many buildings, the current palace grounds are just a small shadow of the prior splendor, with very few structures remaining."
  },
  {
    contentid: '264312',
    contenttypeid: '76',
    title: 'Myeong-dong (명동)',
    createdtime: '20110224204307',
    modifiedtime: '20221213113459',
    tel: '+82-2-778-0333',
    telname: '',
    homepage:
      '<a href="http://www.junggu.seoul.kr/tour/content.do?cmsid=14818&sf_category1=CWS1325&mode=view&page=&cid=98087638" target="_blank" class="web">tour.junggu.seoul.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '66, Eulji-ro, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04538',
    mapx: '126.9850038013',
    mapy: '37.5651434137',
    mlevel: '6',
    overview:
      'Myeong-dong is one of the primary shopping districts in Seoul. The two main streets meet in the center of the block with one beginning from Myeong-dong Subway Station (Seoul Subway Line No. 4) and the other from Lotte Department Store at Euljiro. Many brand name shops and department stores line the streets and alleys. Common products for sale include clothes, shoes, and accessories. Unlike Namdaemun or Dongdaemun, many designer brands are sold in Myeong-dong. In addition, several major department stores have branches here, including Lotte Department Store, Shinsegae Department Store, Myeong-dong Migliore, Noon Square and M Plaza. The department stores carry many premium labels and other fashionable goods at reasonable prices. <br><br>\n\nMyeong-dong also has family restaurants, fast food, plus Korean, Western and Japanese dining options. Many restaurants in Myeong-dong specialize in <em>dongaseu</em> (pork cutlet) and <em>kalguksu</em> (noodle soup). Other businesses in the area include hair salons, banks and theaters.'
  },
  {
    contentid: '2475097',
    contenttypeid: '76',
    title: 'Dongdaemun Design Plaza (동대문디자인플라자 (DDP))',
    createdtime: '20170112193908',
    modifiedtime: '20220907112917',
    tel: '+82-2-2153-0000',
    telname: '',
    homepage:
      '<a href="http://www.ddp.or.kr" target="_blank" title="new window popup" class="web">www.ddp.or.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0204',
    cat3: 'A02040800',
    addr1: '281, Eulji-ro, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04566',
    mapx: '127.0099486810',
    mapy: '37.5675991318',
    mlevel: '6',
    overview:
      "Dongdaemun Design Plaza (DDP) has a meaning of Dream, Design, and Play. It holds various exhibitions, fashion shows, forums, conferences, and other domestic and international events. The building complex is divided into sections, which are named Allimteo, Beaumteo, Sallimteo, DDP Design Museum, Design Market & Eoullim Plaza, and Dongdaemun History & Culture Park. Designed by world-renowned architect Zaha Hadid, the building's exterior attracts the attention of many photographers with its delicate curves and bold shapes."
  },
  {
    contentid: '561382',
    contenttypeid: '76',
    title: 'Bukchon Hanok Village (북촌한옥마을)',
    createdtime: '20080520022823',
    modifiedtime: '20221213164058',
    tel: '+82-2-2148-4161',
    telname: '',
    homepage:
      '<a href="http://hanok.seoul.go.kr/front/index.do" target="_blank" class="web">hanok.seoul.go.kr</a> (Korean, English, Japanese, Chinese)',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010600',
    addr1: '37, Gyedong-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03059',
    mapx: '126.9864254967',
    mapy: '37.5791612548',
    mlevel: '6',
    overview:
      'Surrounded by Gyeongbokgung Palace, Changdeokgung Palace and Jongmyo Shrine, Bukchon Hanok Village is home to hundreds of traditional houses, called <em>hanok</em>, that date back to the Joseon dynasty. The name Bukchon, which literally translates to "northern village," came about as the neighborhood lies north of two significant Seoul landmarks, Cheonggyecheon Stream and Jongno. Today, many of these hanoks operate as cultural centers, guesthouses, restaurants and tea houses, providing visitors with an opportunity to experience, learn and immerse themselves in traditional Korean culture. As Bukchon Hanok Village is an actual neighborhood with people\'s homes, visitors are advised to be respectful at all times while looking around.'
  },
  {
    contentid: '264350',
    contenttypeid: '76',
    title: 'Changgyeonggung Palace (창경궁)',
    createdtime: '20030109182105',
    modifiedtime: '20221213171310',
    tel: '+82-2-762-4868',
    telname: '',
    homepage:
      '<a href="http://cgg.cha.go.kr/" target="_blank">cgg.cha.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010100',
    addr1: '185, Changgyeonggung-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03072',
    mapx: '126.9938554166',
    mapy: '37.5776782272',
    mlevel: '6',
    overview:
      'Located in the heart of Seoul, Changgyeonggung Palace was originally built as Suganggung Palace by the 4th ruler of the Joseon dynasty, King Sejong (r.1418-1450), for his retiring father, King Taejong. It often served as residential quarters for queens and concubines. During the reign of King Seongjong (r.1469-1494), the palace was renovated and renamed to Changgyeonggung Palace. It later became a park with a zoo and a botanical garden during Japanese colonial rule. The palace grounds remained this way until 1983 when restoration of its old grace was completed.'
  },
  {
    contentid: '264571',
    contenttypeid: '76',
    title: 'Gangnam (강남)',
    createdtime: '20050705003841',
    modifiedtime: '20221130100633',
    tel: '+82-2-3423-5114',
    telname: '',
    homepage:
      '<a href="http://www.gangnam.go.kr/main.do" target="_blank">www.gangnam.go.kr</a>  (Korean, English, Japanese, Chinese)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/08/1984608_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/08/1984608_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '1',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: 'Yeoksam-dong, Gangnam-gu, Seoul',
    addr2: '',
    zipcode: '06232',
    mapx: '127.0281573537',
    mapy: '37.4970465429',
    mlevel: '6',
    overview:
      'Gangnam Subway Station area is the prime district for those living south of the Hangang River. Gangnam-daero Avenue links Teheran-ro Road in the east to Jamsil and Sadang in the west. Kyobo Tower Crossroad connects Express Terminal to Noryangjin and west of Seoul. Hannam-daegyo Avenue in the north extends to the north of the Hangang River. A southward direction leads to metropolitan areas such as Seongnam, passing Yangjae and Bundang. <br /><br />Many people tend to gather at Gangnam Subway Station, as the location is geographically and commercially suitable as a meeting point for social gatherings, events, or personal engagements. Hence, during the weekdays it is usually crowded in the evenings while on weekends, areas around Gangnam Subway Station exit numbers 10 and 11, as well as City Theatre, and Giordano are often bustling with people. Visitors travel to Gangnam to take advantage of its convenient transportation, fashion malls, movie theatres, and bookstores. <br /><br />Gangnam-gu Office operates Gangnam Tourist Information Center to offer tourist information to international and domestic visitors and hands-on activities related to tourism. Also, the center operates Medical Tour Center which introduces Gangnam-gu&rsquo;s specializing hospitals and medical treatment as well as Hallyu Experience Hall.'
  },
  {
    contentid: '1810712',
    contenttypeid: '76',
    title: 'Choi Sunu House (최순우 옛집)',
    createdtime: '20130510195854',
    modifiedtime: '20211221200347',
    tel: '+82-2-3675-3401',
    telname: '',
    homepage:
      '<a href="http://www.choisunu.com" target="_blank" web="class">www.choisunu.com</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/18/2031918_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/18/2031918_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '17',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010400',
    addr1: '9, Seongbuk-ro 15-gil, Seongbuk-gu, Seoul',
    addr2: '',
    zipcode: '02880',
    mapx: '127.0003849431',
    mapy: '37.5929960083',
    mlevel: '6',
    overview:
      'The Choi Sunu House is the old residence of Hyegok Choi Sunu (1916-1984), who lived in this house from 1976 until the day he passed away. The house is designated as Korea’s Registered Cultural Property. Choi Sunu was a leading art historian who served as the director of the National Museum of Korea. He devoted his life to rediscovering the beauty of Korean art and made many academic accomplishments in the areas of Korean ceramics, traditional woodcraft, and the history of painting. <br>The house has been open to the public as the Hyegok Choi Sunu Memorial Hall since 2004. The memorial hall displays Choi Sunu’s relics as a permanent exhibition and holds special exhibitions in the fall as well as cultural programs every spring and fall.'
  },
  {
    contentid: '2543150',
    contenttypeid: '76',
    title: 'Baek In-je House (백인제가옥)',
    createdtime: '20180416234208',
    modifiedtime: '20220502155947',
    tel: '+82-2-724-0200',
    telname: '',
    homepage:
      '<a href="http://www.museum.seoul.kr/www/intro/annexIntro/annex_22/annex_22_01.jsp?sso=ok" target="_blank">www.museum.seoul.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/92/2481892_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/92/2481892_image2_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010400',
    addr1: '16, Bukchon-ro 7-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03055',
    mapx: '126.9840701194',
    mapy: '37.5804416194',
    mlevel: '6',
    overview:
      'Baek In-je House in Gahoe-dong, located in Bukchon Hanok Village, is a hanok built during the Japanese administration period that portrays modern hanok features. The structure consists of a main room offering a good view of the whole village, spacious bedrooms, a large garden, and annex buildings. As it withholds the beauty of a traditional hanok while incorporating the modern trend of its time, Baek In-je House is considered to be highly valuable in means of both architecture and history, representing the Bukchon Hanok Village together with Yun Bo-seon House.<br /><br />Baek In-je House was built from black pine, which was first introduced in Seoul during the Gyeongseong Expo in 1907, distinguishing itself from other upper-class houses of its time. Unlike other traditional hanok designs that separate the main building from the other rooms, Baek In-je House connects the two with a hallway, allowing convenient access between the two structures. The house also consists of a Japanese-style hallway and floor mat rooms, reflecting the interior trends of that period. Baek In-je House is also unique in that the main room is partially built as a two-story structure, a style that was never seen in any traditional hanok built during the Joseon period.'
  },
  {
    contentid: '2813573',
    contenttypeid: '76',
    title: 'Nodeulseom Island (노들섬)',
    createdtime: '20220325144143',
    modifiedtime: '20220809164453',
    tel: '+82-2-749-4500',
    telname: '',
    homepage: '<a href="http://nodeul.org/" target="_blank">nodeul.org </a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/65/2638965_image2_1.JPG',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/65/2638965_image2_1.JPG',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '21',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020200',
    addr1: '445, Yangnyeong-ro, Yongsan-gu, Seoul',
    addr2: '',
    zipcode: '04427',
    mapx: '126.9580659298',
    mapy: '37.5177234407',
    mlevel: '6',
    overview:
      "Originally called Jungjido Island until the 1950s, Nodeulseom Island was a sandy plain used for recreational purposes until the areas of Hangang River underwent development in the '60s and '70s. The sand was used to create what seems like an island floating in the middle of the Hangang River. Nodeulseom Island was left abandoned for the next 50 years until 2005, when the Seoul Metropolitan Government purchased the property. After a series of planning and changes, the island was open to the public in 2019 as a recreational area while preserving most of its original form. Nodeulseom Isand's main attractions consist of a live house, bookstore, music lounges, garden, and more, serving as a cultural entertainment spot to the public.&nbsp;<br>"
  },
  {
    contentid: '1747593',
    contenttypeid: '76',
    title: 'Bukhansan National Park (Seoul District) (북한산국립공원(서울))',
    createdtime: '20121105180812',
    modifiedtime: '20211217192717',
    tel: '+82-2-909-0498',
    telname: '',
    homepage:
      '<a href="http://bukhan.knps.or.kr/" target="_blank" title="새창 : 북한산국립공원 사이트로 이동">bukhan.knps.or.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/45/2526645_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/45/2526645_image2_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '17',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010100',
    addr1: '262, Bogungmun-ro, Seongbuk-gu, Seoul',
    addr2: '',
    zipcode: '02700',
    mapx: '126.9943263511',
    mapy: '37.6215453578',
    mlevel: '6',
    overview:
      'Bukhansan Mountain was officially designated as a national park in 1983. The Bukhansan National Park covers both Bukhansan and Dobongsan Mountains, and spans the total area of 80.699 ㎢. At the top of Bukhansan Mountain are Baegundae Terrace (835.6 m), Insubong Peak (810.5 m) and Mangyeongdae Terrace (799.5 m), which gave the mountain the nickname "Samgaksan" or the "three-horned mountain." The mountain had other names: Sambongsan (mountain with three peaks), Hwasan (flower mountain), and Buaak (mountain shaped like a person giving a baby a piggyback ride). The current name, Bukhansan, was given after the Bukhansanseong Fortress was built under King Sukjong of the Joseon dynasty.'
  },
  {
    contentid: '264223',
    contenttypeid: '76',
    title: 'Unhyeongung Royal Residence (서울 운현궁)',
    createdtime: '20030109030920',
    modifiedtime: '20211124181449',
    tel: '+82-2-766-9090',
    telname: '',
    homepage:
      '<a href="http://www.unhyeongung.or.kr/" target="_blank">www.unhyeongung.or.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/71/924371_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/71/924371_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010100',
    addr1: '464, Samil-daero, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03131',
    mapx: '126.9871421746',
    mapy: '37.5764588036',
    mlevel: '6',
    overview:
      "Unhyeongung Royal Residence is a historic site located in Unni-dong, Jongno-gu in Seoul. The residence belonged to Heungseon Daewongun, Emperor Gojong's father and was where the emperor-to-be grew up as a child. Although the residence was a private home for the royal family rather than a place for political affairs, some of the most historically important events took place within the walls of Unhyeongung Royal Residence towards the end of the Joseon dynasty. <br><br>\nWhen Gojong was appointed as king at an early age, Heungseon Daewongun rose in power as king regent. During this time, Unhyeongung Royal Residence went through upscaling renovations, increasing in size and grandeur. After Heungseon Daewongun stepped down from regency, Unhyeongung Royal Residence's reputation slowly deteriorated as the family went through financial difficulties and could not afford to maintain the facilities. The ownership of the residence was confiscated by the Japanese administration in 1912, then returned to Heungseon Daewongun's descendants in 1948. The complex was then purchased by the Seoul Metropolitan Government, followed by renovation efforts in 1993 to recover and preserve whatever was left of the historical site."
  },
  {
    contentid: '264111',
    contenttypeid: '76',
    title: 'Archaeological Site in Amsa-dong, Seoul (서울 암사동 유적)',
    createdtime: '20021227002446',
    modifiedtime: '20210727015826',
    tel: '+82-2-3425-6520',
    telname: '',
    homepage:
      '<a href="http://sunsa.gangdong.go.kr/" target="_blank" class="web">www.sunsa.gangdong.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/19/204019_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/19/204019_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '2',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '875, Olympic-ro, Gangdong-gu, Seoul',
    addr2: '',
    zipcode: '05239',
    mapx: '127.1309239757',
    mapy: '37.5605132450',
    mlevel: '6',
    overview:
      'The Archaeological Site in Amsa-dong reproduces the lifestyle of the Neolithic Era. Even the entrance gate is shaped like a huge dolmen and the trash cans are ancient diagonal-line patterned earthenware. Archaeological Site in Amsa-dong was excavated in 1925 when a flood washed away the soil on the banks of the Hangang River and exposed a large number of diagonal-line patterned earthenware. After several excavations, the Archaeological Site in Amsa-dong was established. <br>\n<br> The site was a location for a massive colony, thus many ancient buildings, stone axes and stone arrows have been uncovered as well as countless diagonal-line patterned earthenware.  The housing site is round with a spot in the center for fire.  The site is colossal and possesses nine mud huts, two exhibition halls displaying ancient artifacts and an open mud hut where visitors can experience life in the Neolithic Era. The site offers many attractions such as mud huts and promenades. Archaeological Site in Amsa-dong is also very educational for children and families who want to learn and experience the Neolithic Age.'
  },
  {
    contentid: '1913218',
    contenttypeid: '76',
    title: 'Seoul Gyeonggyojang House (서울 경교장)',
    createdtime: '20140412015908',
    modifiedtime: '20210915231358',
    tel: '+82-2-735-2038',
    telname: '',
    homepage:
      '<a href="https://museum.seoul.go.kr/www/intro/annexIntro/annex_21/annex_21_01.jsp?sso=ok" target="_blank" class="web">www.museum.seoul.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/58/1568458_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/58/1568458_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '29, Saemunan-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03181',
    mapx: '126.9677163958',
    mapy: '37.5683899481',
    mlevel: '6',
    overview:
      "Gyeonggyojang House, a designated Historic Site, was the location of the provisional government and the place where Baekbeom Kim Koo passed away. Seoul reproduced the historical site, Gyeonggyojang House, to use the area as an educational site. Also, the house exhibits the history of the provisional government in order to see the history more clearly.<br><br>\n\nRestoration work included the demolition of the interior that was changed when the building was turned into a hospital facility and embassy after Kim Koo passed away in 1949. During the work, the remaining parts were maintained with the utmost care. Reconstructed parts were based on the building's floor plan written in Chosun and Architecture (8th edition in 1938). Visitors can see various contents related to the Korean Provisional Government history through relics, video, and information searching corners."
  },
  {
    contentid: '264320',
    contenttypeid: '76',
    title: 'Seoul Namsan Park (남산공원(서울))',
    createdtime: '20030109040423',
    modifiedtime: '20210910000901',
    tel: '+82-2-3783-5900',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/template/sub/namsan.do" target="_blank" title="New window popup">parks.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/83/1981983_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/83/1981983_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '231, Samil-daero, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04628',
    mapx: '126.9922506300',
    mapy: '37.5557113068',
    mlevel: '6',
    overview:
      'Seoul Namsan Park opened in 1968 as a public park and went through renovation in 1991 to better serve the public as a nature-friendly rest  area in the middle of the city. The areas surrounding the park such as Jung-gu, Yejang-dong, Hoehyeon-dong, Yongsan-gu, and Hannam-dong were renovated along with the park for a cleaner and refreshing atmoshere.'
  },
  {
    contentid: '264106',
    contenttypeid: '76',
    title:
      'Seolleung and Jeongneung Royal Tombs [UNESCO World Heritage] (서울 선릉(성종과 정현왕후)과 정릉(중종) [유네스코 세계문화유산])',
    createdtime: '20021220020217',
    modifiedtime: '20210811183800',
    tel: '+82-2-568-1291',
    telname: '',
    homepage:
      '<a href="http://royaltombs.cha.go.kr/" target="_blank">royaltombs.cha.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '1',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '1, Seolleung-ro 100-gil, Gangnam-gu, Seoul',
    addr2: '',
    zipcode: '06153',
    mapx: '127.0471803291',
    mapy: '37.5074206801',
    mlevel: '6',
    overview:
      'Seolleung and Jeongneung Royal Tombs house King Seongjong (1469-1494) and his wife Queen Jeonghyeon in Seolleung Royal Tomb and King Jungjong (1506-1544) of the Joseon dynasty (1392-1910) in Jeongneung Royal Tomb. A designated Historic Site, Seolleung and Jeongneung Royal Tombs is located in downtown Seoul, but because it is not well known, it provides a space for a tranquil walk along the rock wall path.'
  },
  {
    contentid: '264308',
    contenttypeid: '76',
    title: 'Gyeonghuigung Palace (경희궁)',
    createdtime: '20030109040004',
    modifiedtime: '20210714021010',
    tel: '+82-2-724-0274',
    telname: '',
    homepage:
      '<a href="http://www.heritage.go.kr/heri/cul/culSelectDetail.do?pageNo=1_1_1_1&ccbaCpno=1331102710000" target="_blank">www.heritage.go.kr</a><br><a href="https://museum.seoul.go.kr/www/intro/annexIntro/annex_20/annex_20_01.jsp?sso=ok" target="_blank">museum.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/31/1568231_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/31/1568231_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010100',
    addr1: '45, Saemunan-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03177',
    mapx: '126.9685079323',
    mapy: '37.5704425020',
    mlevel: '6',
    overview:
      'Gyeonghuigung Palace, Historic Site No. 271, was originally called the large palace by Saemun Gate, or the Western Palace, for its location within the city. It was not until the eighth year of Gwanghaegun (1616) that the palace was used as a royal residence for the king, changing the name to Gyeongdeokgung Palace. The name later changed again to the current Gyeonghuigung Palace in 1760. The palace grounds included many halls but they were mostly all burned down in a fire in 1829. After the Japanese occupation began, all remaining buildings on the site were torn down and the palace grounds were turned into Gyeongseong Middle School (now Seoul High School). The school moved to Gangnam area in 1987, afterwhich the previous location was turned into a park. The palace grounds currently hold Seoul Museum of Art and walking paths, as well as a restoration of Heunghwamun Gate, the main gate of the palace, and Sungjeongjeon Hall, the main hall, completed in November 1994.'
  },
  {
    contentid: '2037040',
    contenttypeid: '76',
    title: 'Seochon Village (서촌마을)',
    createdtime: '20151030024535',
    modifiedtime: '20210619012711',
    tel: '',
    telname: '',
    homepage: '',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/94/2678694_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/94/2678694_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '16, Jahamun-ro 6-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03037',
    mapx: '126.9729684191',
    mapy: '37.5781277997',
    mlevel: '6',
    overview:
      "Seochon Village, literally meaning west village, is named in reference to its location west of Gyeongbokgung Palace. The old hanok houses lining the long alleys well harmonize with newly emerging shops and stores. Walking through the alleys that resembles a big maze, visitors will be nicely surprised by murals and adorable pictures.  \n<br><Br>\nA hint of Korea's tradition is truly well balanced with many modern and stylish spaces that bring out the authentic and simple beauty and coziness of Seochon Village."
  },
  {
    contentid: '264115',
    contenttypeid: '76',
    title:
      'Heolleung and Illeung Royal Tombs [UNESCO World Heritage] (서울 헌릉(태종,원경왕후)과 인릉(순조,순원왕후) [유네스코 세계문화유산])',
    createdtime: '20021227005905',
    modifiedtime: '20210724001220',
    tel: '+82-2-445-0347',
    telname: '',
    homepage:
      '<a href="http://royaltombs.cha.go.kr/" target="_blank" title="New window popup">royaltombs.cha.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/42/1985242_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/42/1985242_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '15',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '36-10, Heonilleung-gil, Seocho-gu, Seoul',
    addr2: '',
    zipcode: '06795',
    mapx: '127.0837087516',
    mapy: '37.4653567754',
    mlevel: '6',
    overview:
      'Heolleung and Illeung Royal Tombs house the mounds for two kings of the Joseon dynasty (1392-1910) and their wives:  King Taejong (1401-1418) and Queen Wongyeong, along with King Sunjo (1800-1834) and Queen Sunwon. Together, the tombs are referred to as Heonilleung Royal Tomb. The site possesses numerous stone statues and vestiges, and is a good place to experience the culture of the Joseon dynasty.'
  },
  {
    contentid: '264132',
    contenttypeid: '76',
    title: 'The National Assembly Building (국회의사당)',
    createdtime: '20030103194820',
    modifiedtime: '20210715235106',
    tel: '+82-2-788-2114',
    telname: '',
    homepage:
      '<a href ="http://www.assembly.go.kr" target ="_blank" class="web"> www.assembly.go.kr</a> (Korean, English)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/61/1811361_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/61/1811361_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '20',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050600',
    addr1: '1, Uisadang-daero, Yeongdeungpo-gu, Seoul',
    addr2: '',
    zipcode: '07233',
    mapx: '126.9142167446',
    mapy: '37.5319710006',
    mlevel: '6',
    overview:
      'With 24 granite pillars, a splendid blue dome, and white exterior, the National Assembly Building is a beautiful piece of architecture. This historic building was completed in 1975 after six years of construction. The pillars and the dome symbolize the various opinions of the public emerging as one. The building is a favorite among tourists as it is located next to the Hangang River. <br><br>The National Assembly Building consits of visitors center, walking area, and benches alongside the Hangang River. The easiest way to visit the National Assembly Building is by applying at the visitors center. One can tour various sections of the National Assembly Building as well as the main conference area. The application process takes roughly twenty minutes. The drawback is that it does not offer any foreign language service. Those who are interested in seeing Korean politics in action may also see sessions as they proceed.'
  },
  {
    contentid: '264473',
    contenttypeid: '76',
    title: 'Samcheong-dong Street (삼청동길)',
    createdtime: '20040228025320',
    modifiedtime: '20210616195420',
    tel: '+82-2-120',
    telname: '',
    homepage:
      '<a href="https://bit.ly/3xmsN66" target="_blank">www.visitseoul.net</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '107, Samcheong-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03049',
    mapx: '126.9818368607',
    mapy: '37.5849938278',
    mlevel: '6',
    overview:
      'It is said that Samcheong-dong was named from the story about the three "cheong" (Chinese character meaning clean) of the area, namely the mountain, water, and people. Another theory is that the origin of the region\'s name came from Samcheongjeon Hall where three tablets called "Taecheong," "Sangcheong," and "Okcheong," were set up based on Taoism. Samcheong-dong Street features a mixture of old scenes of hanok buildings with traditional beauty and modern scenes of galleries and cafés, creating a unique atmosphere. Visitors can feel the abundant cultural mood at every corner of the street through the art galleries, museums, antique shops, and quiet pathways.'
  },
  {
    contentid: '1348621',
    contenttypeid: '76',
    title: 'Seoul National Cemetery (국립서울현충원)',
    createdtime: '20110802233005',
    modifiedtime: '20210622221325',
    tel: '+82-2-813-9625',
    telname: '',
    homepage:
      '<a href="http://www.snmb.mil.kr/" target="_blank" class="web">www.snmb.mil.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '12',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '210, Hyeonchung-ro, Dongjak-gu, Seoul',
    addr2: '',
    zipcode: '06984',
    mapx: '126.9732511193',
    mapy: '37.5013561691',
    mlevel: '6',
    overview:
      'The rear area of Seoul National Cemetery is surrounded on three sides by the foothills of Gwanaksan Mountain around Dongjakbong Peak. Towards the front, the cemetery overlooks the meandering Hangang River.\n<br><br>\nSeoul National Cemetery is situated on a plot of land measuring approximately 1,430,000 ㎡. Entombed here are the remains of 165,000 martyrs and soldiers, police officers, and reserve forces who sacrificed themselves for their country. Enshrined within the Memorial Tower are memorial tablets of approximately 104,000 soldiers who died during the Korean War, but whose bodies were never found along with the remains of approximately 7,000 unknown soldiers whose bodies were found. The remains of more than 54,000 martyred patriots have been buried in the Burial Plots, which are divided into various sections: graves of soldiers, police officers, meritorious citizens, and key figures of the provisional government. Every year on June 6th (Memorial Day), memorial services and events are held at the Seoul National Cemetery to honor the brave patriots who fought for the country.\n<br><br>\nFacilities consist of the Memorial Gate, Memorial Tower, Chungseong Fountain Tower, Holy Ground, Photographic Exhibition House, Educational Movie Theater, and Relics Exhibition House. In 1955, the cemetery was established as the National Military Cemetery and then was elevated to the status of National Cemetery ten years later in 1965. In 1996, the managing institution also underwent a name change from "National Cemetery Management Office" to "National Memorial Board."'
  },
  {
    contentid: '1748351',
    contenttypeid: '76',
    title: 'Deoksugung Stone Wall Path (덕수궁 돌담길)',
    createdtime: '20121106202438',
    modifiedtime: '20210616200125',
    tel: '+82-2-120',
    telname: '',
    homepage:
      '<a href="http://www.deoksugung.go.kr/" target="_blank" class="web">www.deoksugung.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/50/2658350_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/50/2658350_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: 'jiha 101, Sejong-daero, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04519',
    mapx: '126.9748935853',
    mapy: '37.5660820124',
    mlevel: '6',
    overview:
      'Stretching approximately 900 meters in length, Deoksugung Stone Wall Path was Korea’s first successful attempt at creating a comprehensive urban space where both people and nature can coexist. The street was built using eco-friendly materials and the utmost precautions were taken to ensure pedestrian safety. There are over 20 benches and 130 trees along the road offering great places to rest and enjoy the unique atmosphere. <br>\n<br> Walking along Deoksugung Stone Wall Path is a memorable experience. The romantic street is an ideal date spot for couples to stroll along and also makes for an excellent cultural walk, being located near Seoul Museum of Art, Seoul Museum of History, and important historical complexes.'
  },
  {
    contentid: '1876944',
    contenttypeid: '76',
    title: 'Namsan Octagonal Pavilion (남산 팔각정)',
    createdtime: '20131230194247',
    modifiedtime: '20210619005030',
    tel: '+82-2-3783-5900',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/template/sub/namsan.do">parks.seoul.go.kr</a> <br> (Korean, English, Japanese, Chinese, French, Spanish)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/72/1567972_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/72/1567972_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050600',
    addr1: '105, Namsangongwon-gil, Yongsan-gu, Seoul',
    addr2: '',
    zipcode: '04628',
    mapx: '126.9876206116',
    mapy: '37.5516394747',
    mlevel: '6',
    overview:
      "Originally known as Unamjeong Pavilion, the pavilion was built in 1959 to commemorate Rhee Syngman. It was demolished by the 4.19 movement in 1960 and was rebuilt on November 11, 1968. This pavilion now sits atop Namsan Mountain, with views covering the entirety of Seoul below. As it is a prime spot to view the first sunrise of the year, the annual sunrise festival takes place every New Year's Day."
  },
  {
    contentid: '778924',
    contenttypeid: '76',
    title:
      'Uireung Royal Tomb [UNESCO World Heritage] (서울 의릉(경종, 선의왕후) [유네스코 세계문화유산])',
    createdtime: '20090817182624',
    modifiedtime: '20210603223940',
    tel: '+82-2-964-0579',
    telname: '',
    homepage:
      '<a class="web" href="http://royaltombs.cha.go.kr" target="_blank">royaltombs.cha.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/80/2690680_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/80/2690680_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '17',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '146-20, Hwarang-ro 32-gil, Seongbuk-gu, Seoul',
    addr2: '',
    zipcode: '02789',
    mapx: '127.0582349259',
    mapy: '37.6035486003',
    mlevel: '6',
    overview:
      'Uireung is the royal tomb of King Gyeongjong (reign 1720-1724), the 20th ruler of the Joseon dynasty, and his second wife, Queen Seonui.<br><br>\nKing Gyeongjong was the first son of King Sukjong and Janghuibin, who was one of King Sukjong’s concubines. King Gyeongjong, who was born weak and anemic, died four years after becoming the king, without any great political achievements. Uireung tombs differ from the other royal double tombs in that they are not placed side-by-side. Instead, according to geomantic theory, one tomb has been placed directly behind the other one. The arrangement also shows that when making tombs, Korean ancestors did their best to protect the natural environment. Another feature of Uireung Royal Tomb is the stone fence raised using twelve stone posts. Each post has a letter inscribed,  representing one of the twelve sibijisin gods.'
  },
  {
    contentid: '1051832',
    contenttypeid: '76',
    title: 'Children’s Grand Park (서울 어린이대공원)',
    createdtime: '20100630183910',
    modifiedtime: '20210507191712',
    tel: '+82-2-450-9311',
    telname: '',
    homepage:
      '<a href="http://www.sisul.or.kr/" target="_blank"class="web">www.sisul.or.kr</a> (Korean, English)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/02/2028002_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/02/2028002_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '6',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010500',
    addr1: '216, Neungdong-ro, Gwangjin-gu, Seoul',
    addr2: '',
    zipcode: '04991',
    mapx: '127.0807288607',
    mapy: '37.5494219613',
    mlevel: '6',
    overview:
      'Situated in Gwangjin-gu, Seoul Children’s Grand Park houses various facilities for families, including a zoo, botanical garden, amusement rides, and diverse performance events within a vast area. Opened on Children’s Day (May 5) in 1973, the park is full of attractions that appeal to children and the young-at-heart. It was renovated on Children’s Day 2009 to repair old and worn facilities. It became an even more spacious and pleasant park thanks to the renovation work.'
  },
  {
    contentid: '264317',
    contenttypeid: '76',
    title: 'Daehangno (University Street) (대학로)',
    createdtime: '20030109040302',
    modifiedtime: '20210325221134',
    tel: '+82-2-2148-1114',
    telname: '',
    homepage:
      '<a href="http://tour.jongno.go.kr/tourMain.do" target="_blank">tour.jongno.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/86/1554786_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/86/1554786_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '104, Daehak-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03087',
    mapx: '127.0022045820',
    mapy: '37.5802919622',
    mlevel: '6',
    overview:
      'Daehangno is an artistic neighborhood that stretches 1.1 kilometers from Jongno 5-ga Intersection to Hyehwa-dong Rotary. The area is filled with culture and performing arts facilities, with the center of all this being Marronnier Park. Visitors can find performances taking play every day at the many theaters large and small, as well as restaurants serving a range of cuisines. The area is especially active on weekends and during the street festival period.'
  },
  {
    contentid: '1747984',
    contenttypeid: '76',
    title: 'Mongchontoseong Fortress (서울 몽촌토성)',
    createdtime: '20121106012128',
    modifiedtime: '20210427012550',
    tel: '+82-2-2147-2814',
    telname: '',
    homepage:
      '<a href="http://korean.visitseoul.net/nature/%EB%AA%BD%EC%B4%8C%ED%86%A0%EC%84%B1_/2210" target="_blank">korean.visitseoul.net</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/14/1567814_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/14/1567814_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '18',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010200',
    addr1: '424, Olympic-ro, Songpa-gu, Seoul',
    addr2: '',
    zipcode: '05540',
    mapx: '127.1229758237',
    mapy: '37.5209871362',
    mlevel: '6',
    overview:
      'Mongchontoseong Fortress is an earthen fortification from the Baekje dynasty (18 BC - AD 660). It was built sometime between the 3rd and 4th centuries, using the natural protection offered by a tributary to the Hangang River on one side and wooden barricades for added defense on the other side. The fortress has been designated as Historic Site No. 297, and is currently located inside Seoul Olympic Park.<br><br>\nMongcheontoseong Fortress features an overlapping structure of the outer and inner fortifications that were built along the hill lands descending down from Namhansanseong Fortress. On display inside the fortress are artifacts excavated from the site that date back to the Baekje dynasty. The exhibited items include various earthenware and living tools. The site also displays dugout hut and storage pit sites in the state they were at the time of excavation.'
  },
  {
    contentid: '1747995',
    contenttypeid: '76',
    title: 'Seoul Seokchon-dong Ancient Tombs (서울 석촌동 고분군)',
    createdtime: '20121106012434',
    modifiedtime: '20210226172823',
    tel: '+82-2-421-0970',
    telname: '',
    homepage:
      '<a href="http://www.cha.go.kr/" target="_blank">www.cha.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/89/203889_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/89/203889_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '18',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '21, Garak-ro 7-gil, Songpa-gu, Seoul',
    addr2: '',
    zipcode: '05682',
    mapx: '127.1028309684',
    mapy: '37.5021945110',
    mlevel: '6',
    overview:
      'The Ancient Tombs in Seokchon-dong were found and investigated as part of the city development project in Jamsil district. It was impossible to determine the full scale of the ancient tombs in this area due to the severity of destruction. The largest tomb, the third tomb, measures 49.6 meters from east to west, 43.7 meters from south to north, and 4 meters in x_height. The tomb features three layers of stones topped by a smooth mound, which is a tomb style originating from the Goguryeo dynasty (37 BC-AD 668). The tombs are presumed to belong to one of the earliest leaders of the Baekje dynasty (18 BC-AD 660), which was founded by the people of Goguryeo who had come down southwards to establish a new kingdom around the Hangang River basin. <br><br>\n\nThe square-shaped fourth tomb features a structure similar to the third tomb. Many pieces of earthenware from the early Baekje era were found in the fourth tomb. Also excavated around this site was a gold spangle earring. The third and fourth tombs have been registered as Historic Site No. 243. The tomb site offers valuable information concerning the culture and customs of the Baekje dynasty in its golden age around the 4th century, as well as the relations between the three ancient kingdoms (Goguryeo, Baekje, and Silla) around that time.'
  },
  {
    contentid: '264113',
    contenttypeid: '76',
    title:
      'Jeongneung Royal Tomb  [UNESCO World Heritage] (서울 정릉(신덕왕후) [유네스코 세계문화유산])',
    createdtime: '20021227004147',
    modifiedtime: '20210209193631',
    tel: '+82-2-914-5133',
    telname: '',
    homepage:
      '<a title="new window popup" href="http://royaltombs.cha.go.kr" target="_blank">royaltombs.cha.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/91/2622291_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/91/2622291_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '17',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '116, Arirang-ro 19-gil, Seongbuk-gu, Seoul',
    addr2: '',
    zipcode: '02813',
    mapx: '127.0063452451',
    mapy: '37.6023505830',
    mlevel: '6',
    overview:
      "Jeongneung Royal Tomb is the tomb of Queen Sindeok, the second wife of King Taejo (1392-1398), founder of the Joseon dynasty (1392-1910). The queen met a sudden death due to health complications. Although one of her sons was the crown prince, he was killed by a successive brother, Yi Bang-won, in order to obtain the throne. After Yi Bang-won rose to the throne as King Taejong, he relocated Queen Sindeok's tomb to outside of the city walls."
  },
  {
    contentid: '1382671',
    contenttypeid: '76',
    title: 'King Sejong Statue (세종대왕 동상)',
    createdtime: '20110909001318',
    modifiedtime: '20210201232717',
    tel: '+82-2-2133-7713',
    telname: '',
    homepage: '',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/41/2549141_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/41/2549141_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050400',
    addr1: '175, Sejong-daero, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03172',
    mapx: '126.9768376800',
    mapy: '37.5721757834',
    mlevel: '6',
    overview:
      'The King Sejong Statue was erected at the center of Gwanghawmun Square, in front of Gyeongbokgung Palace. Sitting with a gentle smile on his face and a book in his hand, the 6.2-meter tall bronze statue celebrates the king and his great achievements. King Sejong was called "The People\'s Hero," loved by his subjects because of his efforts to improve their lives and the kingdom.<br><br>\nIn front of the statue lie a celestial globe, a rain gauge, and a sundial, all of which King Sejong invented himself during his reign. Behind the statue, there are six columns with golden carvings depicting the King\'s major accomplishments, as well as an underground passage to the Story of King Sejong exhibition hall, operated by the Sejong Center. <br><br>\nKing Sejong (r.1418-1450) is best remembered as the inventor of Hangeul, the Korean alphabet. During his reign, he consolidated the basis for ruling the Joseon dynasty by incorporating Confucian philosophy into politics. Furthermore, he led the nation through great strides in agriculture, literature, science, and technology.'
  },
  {
    contentid: '1887247',
    contenttypeid: '76',
    title: 'Hangang River (한강)',
    createdtime: '20140120191419',
    modifiedtime: '20210128222027',
    tel: '+82-2-120',
    telname: '',
    homepage:
      '<a href="http://hangang.seoul.go.kr/" target="_blank" title="new window popup" class="web">hangang.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/87/629687_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/87/629687_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '16',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010500',
    addr1: '257, Gangbyeonbuk-ro, Seongdong-gu, Seoul',
    addr2: '',
    zipcode: '04770',
    mapx: '127.0416216085',
    mapy: '37.5389280323',
    mlevel: '6',
    overview:
      'The Hangang River flows through the capital city of Seoul, starting from three smaller streams in the central areas of Gangwon-do, Chungcheongbuk-do, and Gyeonggi-do. The river has witnessed the history of the Korean people for over five thousand years, through good and bad times. The riverside parks offer a nice retreat for the citizens of Seoul.'
  },
  {
    contentid: '264107',
    contenttypeid: '76',
    title: 'Apgujeong Rodeo Street (압구정 로데오거리)',
    createdtime: '20021220020240',
    modifiedtime: '20201118173302',
    tel: '+82-2-3445-0111',
    telname: '',
    homepage:
      '<a href="https://www.gangnam.go.kr/board/B_000733/40494/view.do?mid=FM010407&pgno=2&keyfield=bdm_main_title" target="_blank">www.gangnam.go.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '1',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: 'Apgujeong-dong, Gangnam-gu, Seoul-si',
    addr2: '',
    zipcode: '06017',
    mapx: '127.0388971983',
    mapy: '37.5268766055',
    mlevel: '6',
    overview:
      "Apgujeong Rodeo Street is the main fashion trend street of Korea that arose in the early '90s. In the past, the street was famous for seeing people wearing luxurious clothing and driving foreign cars, but now it has become a representative spot reflecting youth culture and the latest fashion trends.<br><br>\n\nThe side streets off the main road are lined with a wide arrange of fashion-related shops, such as clothing stores, shoe shops, accessory shops, and luxury brand discount stores. Dermatology & plastic surgery clinics and hair shops are also located in abundance here.<br>\n<br>\n The street features the splendid atmosphere which is made up with fancy neon lights, and people walking around the area. Galleria Department Store is one of the main attractions in Apgujeong Rodeo Street where people can find internationally famous brands such as Prada, Bally, Ferragamo, Gucci, and more. In addition to shopping, visitors can enjoy dining at great restaurants in the area."
  },
  {
    contentid: '1887239',
    contenttypeid: '76',
    title: 'Yangcheonhyanggyo Local Confucian School (양천향교)',
    createdtime: '20140120185329',
    modifiedtime: '20210106201727',
    tel: '+82-2-2659-0076',
    telname: '',
    homepage:
      '<a href="http://www.hyanggyo.net" target="_blank"\n>www.hyanggyo.net</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/18/2661818_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/18/2661818_image2_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '4',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010700',
    addr1: '53, Yangcheon-ro 47na-gil, Gangseo-gu, Seoul',
    addr2: '',
    zipcode: '07521',
    mapx: '126.8400029129',
    mapy: '37.5729593554',
    mlevel: '6',
    overview:
      'Yangcheonhyanggyo Local Confucian School is the only educational institution of the Joseon dynasty remaining in Seoul, and as such was designated Seoul Monument No. 8. Built in the 12th year of Joseon King Taejong (1411), the old school was entirely restored in 1981. There are eight buildings in the premises, including Daeseongjeon Hall, Myeongnyundang Lecture Hall, and Jeonsacheong Hall to name a few. A national ritual service for Confucius is held here twice a year: once in spring and once in fall. Also, various programs are offered to teach Chinese characters, calligraphy, or Oriental painting to regular citizens, as well as elementary, junior, and high school students.'
  },
  {
    contentid: '1114212',
    contenttypeid: '76',
    title: 'Dream Forest (북서울 꿈의숲)',
    createdtime: '20101020201443',
    modifiedtime: '20200929231621',
    tel: '+82-2-2289-4000',
    telname: '',
    homepage:
      '<a href="http://parks.seoul.go.kr/template/sub/dreamforest.do" target="_blank" title="_blank">parks.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/86/2526686_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/86/2526686_image2_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '3',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010500',
    addr1: '173, Wolgye-ro, Gangbuk-gu, Seoul',
    addr2: '',
    zipcode: '01228',
    mapx: '127.0407498436',
    mapy: '37.6233876457',
    mlevel: '6',
    overview:
      'Dream Forest, previously known as Odong Neighborhood Park, is located in Gangbuk-gu, Seoul. Renovated and reopened in October 2009, Dream Forest is the fourth largest park after World Cup Park, Olympic Park, and Seoul Forest and the first large-scale green park created in the Gangbuk area. <br><br>\nMajor attractions of the park include Wolyeongji Pond, Grass Square, Wolgwangpokpo Falls, Aewoljeong Pavilion, Chilbokji Falls, Event Garden, Children’s Gallery, Wild Grass Garden, Deer Ranch, Exploring Path, Forest Rest, and a water park. Recently, the Changnyeongwigung Ritual House (National Registered Cultural Heritage No. 40) has been restored with other traditional landscape architectures such as a pond, pavilion and waterfall created nearby to double the genuine beauty of a traditional Korean park. <br><br>\nThe slanted hillside which served as sleigh slopes is now a complex cultural space with Northern-Seoul Art Center that houses a fantastic-looking observatory, performance hall, book café, gallery, restaurant, jumping fountain, and children’s playground.'
  },
  {
    contentid: '264478',
    contenttypeid: '76',
    title: 'Naksan Park (낙산공원)',
    createdtime: '20040304011045',
    modifiedtime: '20200915185742',
    tel: '+82-2-743-7985',
    telname: '',
    homepage:
      '서울의 공원 <a href="http://parks.seoul.go.kr/" target="_blank" title="서울의 공원 사이트로 이동">parks.seoul.go.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/87/1568087_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/87/1568087_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '41, Naksan-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03085',
    mapx: '127.0065125148',
    mapy: '37.5805725621',
    mlevel: '6',
    overview:
      'Naksan Park gets its name from its camel hump-like appearance. The mountain is a \nsolid granite bedrock. The Joseon royal family enjoyed the natural beauty of the granite mountain, but during the Japanese Colonial Period, a hasty manner of urban planning resulted in the demolition of most parts \nof the mountain.  In an effort to save the remaining green belts, Naksan was designated as \na park on June 10, 2002.  Located in the center of the Seoul, this historical and beautiful park allows its visitors to view the magnificence of the entire city.'
  },
  {
    contentid: '2035491',
    contenttypeid: '76',
    title: 'Dapsimni Antique Art Street (답십리 고미술상가)',
    createdtime: '20151024021340',
    modifiedtime: '20200918234345',
    tel: '+82-2-2249-0336',
    telname: '',
    homepage: '',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/14/1917414_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/14/1917414_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '11',
    cat1: 'A04',
    cat2: 'A0401',
    cat3: 'A04010600',
    addr1: '99, Gomisul-ro, Dongdaemun-gu, Seoul',
    addr2: '',
    zipcode: '02622',
    mapx: '127.0575972141',
    mapy: '37.5642059383',
    mlevel: '6',
    overview:
      'Dapsimni Antique Art Street is where travelers can stumble upon valuable old paintings, antique furniture and pottery as well as a variety of household items. These antique shops used to be scattered throughout the area of Cheonggyecheon Stream 8(pal)-ga, Itaewon, and Ahyeon-dong, but have gathered within Dapsimni area since the mid-1980s. There are approximately 140 shops along the streets. <br><br>\nIt is quite fun to browse through antiquities including wooden candlesticks, grandfather clocks, and old picture frames, items which are usually hard to find in regular stores. These rare items attract not only Koreans but also international visitors to this street. While shops in Insa-dong are popular for selling high-quality antiques, shops in Dapsimni Art Street are popular for offering a wide assortment of antiques at reasonable prices.'
  },
  {
    contentid: '2497803',
    contenttypeid: '76',
    title: 'Seoullo 7017 (서울로 7017)',
    createdtime: '20170627231008',
    modifiedtime: '20200828020139',
    tel: '+82-2-120',
    telname: '',
    homepage:
      '<a href="http://seoullo7017.co.kr" target="_blank" title="새창: 서울로7017 홈페이지로 이동">seoullo7017.co.kr</a>',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/70/2495570_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/70/2495570_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0202',
    cat3: 'A02020700',
    addr1: '405, Hangang-daero, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04509',
    mapx: '126.9706609645',
    mapy: '37.5545193912',
    mlevel: '6',
    overview:
      'In the 1970s, an elevated road was built to connect the eastern and western sides around Seoul Station. However, the road was closed to road traffic due to safety issues. After this, rather than tearing down the existing structure, the road was transformed into Seoullo 7017, a new pedestrian road attraction. <br><br>\n\nSeoullo 7017 gets its name from the numbers that represents its transformation, from being a traffic road in the \'70s to a sky garden in 2017. The "17" also has a deeper meaning, with Seoullo 7017 being divided into 17 unique sections, and the road being located 17 meters above the ground.<br><br> \n\nThere are a variety of facilities along Seoullo 7017, including an information center, cafes, gardens, and stages. Seoullo 7017 itself is open all day, every day for visitors to enjoy at their leisure. Visitors interested in a guided tour can sign up for the guided walking tour through the official Visit Seoul website.'
  },
  {
    contentid: '264122',
    contenttypeid: '76',
    title: '63 Square (63스퀘어)',
    createdtime: '20021229000750',
    modifiedtime: '20200714015313',
    tel: '+82-2-789-5663',
    telname: '',
    homepage:
      '<a href="http://www.63.co.kr/" target="_blank">www.63.co.kr</a> (Korean, English, Japanese, Chinese)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/86/2526386_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/86/2526386_image2_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '20',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050600',
    addr1: '50, 63-ro, Yeongdeungpo-gu, Seoul',
    addr2: '',
    zipcode: '07345',
    mapx: '126.9403285961',
    mapy: '37.5198673186',
    mlevel: '6',
    overview:
      'With 63 floors measuring a total x_height of 249 meters, 63 Square is one of Korea’s tallest and most recognized skyscrapers. 63 Square boasts spectacular views of the Hangang River and the surrounding Bugaksan, Namsan and Gwanaksan Mountains. The building also offers an outstanding vantage point when viewing the sunset over the city.'
  },
  {
    contentid: '2541628',
    contenttypeid: '76',
    title: 'Eight Scenic Views of Bukchon (북촌 8경)',
    createdtime: '20180404195824',
    modifiedtime: '20200429225554',
    tel: '+82-2-2148-4161',
    telname: '',
    homepage:
      '<a href="http://bukchon.seoul.go.kr" target="_blank">bukchon.seoul.go.kr</a> (Korean, English, Japanese, Chinese)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/80/933780_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/80/933780_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010600',
    addr1: '37, Gyedong-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03059',
    mapx: '126.9862366274',
    mapy: '37.5790751499',
    mlevel: '6',
    overview:
      "Bukchon, literally translated to northern village, refers to the neighborhood located north of Cheonggyecheon Stream and Jongno. The southern land of Jongno, which is present day Namsan, was referred to as Namchon, meaning southern village. Bukchon Village was resided mostly by relatives of royal families and powerful authorities while Namchon Village was settled by middle class government officials during the Joseon period. Now referred to as the Bukchon Hanok Village, the neighborhood has become one of Korea's most iconic tourist attractions that provide various photo ops. Visitors can take in the outlook of Seoul together with traditional hanok buildings by stopping by the spots of Eight Scenic Views of Bukchon.<br>\n<br>\n[Eight Scenic Views of Bukchon]<br>\nScenic View 1 - View of Chengdeokgung Palace over the stonewall. <br>\nScenic View 2 - View of Wonseo-dong Handicraft Road<br>\nScenic View 3 - View of hanok at Gahoe-dong 11-bunji area<br>\nScenic View 4 - View of Gahoe-dong 31-bunji from the hilltop<br>\nScenic View 5 - View of Gahoe-dong alley (downhill)<br>\nScenic View 6 - View of Gahoe-dong alley (uphill)<br>\nScenic View 7 - View of Gahoe-dong 31-bunji alleyway<br> \nScenic View 8 - View from the Samcheong-dong stone stairway"
  },
  {
    contentid: '1382366',
    contenttypeid: '76',
    title: 'Buam-dong (부암동)',
    createdtime: '20110908202217',
    modifiedtime: '20200326224215',
    tel: '+82-2-2148-1807',
    telname: '',
    homepage:
      '<a href="http://tour.jongno.go.kr" target="_blank" class="web">tour.jongno.go.kr</a> (Korean, English, Japanese, Chinese)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/41/2036441_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/41/2036441_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '145, Changuimun-ro, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03022',
    mapx: '126.9640854894',
    mapy: '37.5924870824',
    mlevel: '6',
    overview:
      'Buam-dong is a neighborhood in central Seoul that was once occupied mostly by artists and writers. Today, modern galleries, coffee shops, and restaurants stand side by side with old mills and barber shops on the narrow alleyways, making Buam-dong a sophisticated yet classically charming destination.'
  },
  {
    contentid: '1930523',
    contenttypeid: '76',
    title: 'Seoul Yakhyeon Catholic Church (서울 약현성당)',
    createdtime: '20140702020510',
    modifiedtime: '20200326020220',
    tel: '+82-2-362-1891',
    telname: '',
    homepage:
      '<a href="http://www.yakhyeon.or.kr/" target="_blank">www.yakhyeon.or.kr</a> (Korean only)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/81/1981981_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/81/1981981_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0201',
    cat3: 'A02010900',
    addr1: '447-1, Cheongpa-ro, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04506',
    mapx: '126.9674194623',
    mapy: '37.5591437954',
    mlevel: '6',
    overview:
      'Yakhyeon Catholic Church was established as a result of Korea gaining religious freedom in the 23rd year of King Gojong’s reign (1886) and the subsequent increase of the Catholic population. In 1891, Myeongdong Cathedral\'s head priest Doucet laid down the foundation stone in Hap-dong. Coadjutor bishop Coste was in charge of design and construction and the building was eventually completed in 1892. The church was named after "Yakjeonhyeon," or a hill of medicinal herbs. This is because the place where the church is located was once a hilly area covered with medicinal herbs. Later on, Yakjeonhyeon was shortened to Yakhyeon and it became the name of the hilly area between Malli-dong and Seoul Station.\n<br><br>\nYakhyeon Catholic Church was the first Western-style church ever built in Korea. It\'s Gothic architecture features a 12-meter-wide and 32-meter-long cruciform construction with low arched windows and a pointed-arch entrance gate.'
  },
  {
    contentid: '1382517',
    contenttypeid: '76',
    title: 'Statue of Admiral Yi Sun-Shin (충무공 이순신 동상)',
    createdtime: '20110908230004',
    modifiedtime: '20200104012946',
    tel: '',
    telname: '',
    homepage: '',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/09/1568209_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/09/1568209_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050400',
    addr1: '175, Sejong-daero, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03172',
    mapx: '126.9769182186',
    mapy: '37.5724868597',
    mlevel: '6',
    overview:
      'The Statue of Admiral Yi Sun-Shin was erected at the front of Gwanghwamun Square on April 27, 1968, in honor of the brave spirit and leadership of the Admiral. At 17 meters tall, the bronze statue stands firmly with a sword in his right hand, representing protection and patriotism. In front of the statue is a miniature turtle ship that the Admiral built, and at each front corner are two drums that were used to increase the morale of soldiers going to the battlefield.'
  },
  {
    contentid: '1241248',
    contenttypeid: '76',
    title: 'Dongdaemun Stationery Store Street (동대문 문구완구거리)',
    createdtime: '20110324222335',
    modifiedtime: '20200324221716',
    tel: '+82-2-1330',
    telname: '',
    homepage:
      '<a href="http://tour.jongno.go.kr" target="_blank" title="새창 : 종로 문화 관광 사이트로 이동">tour.jongno.go.kr </a> (Korean, English, Japanese, Chinese)',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '23',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '36, Jong-ro 52-gil, Jongno-gu, Seoul',
    addr2: '',
    zipcode: '03120',
    mapx: '127.0144065057',
    mapy: '37.5712043487',
    mlevel: '6',
    overview:
      'Dongdaemun Stationary Store Street is located in Changsin-dong near Dongdaemun Station, and is a wholesale market selling toys and stationery. Almost 100 stationery stores are packed in the area, selling robots, dolls, play houses, various school supplies, party and event items, stationery, and toys. <br>\nVisitors can purchase any items at prices 30-40% off of regular market prices and sometimes one can get bigger discounts.'
  },
  {
    contentid: '1011983',
    contenttypeid: '76',
    title: 'Banpo Bridge Rainbow Fountain (반포대교 달빛무지개분수)',
    createdtime: '20100430002957',
    modifiedtime: '20191127181705',
    tel: '+82-2-3780-0578',
    telname: 'Hangang River Management',
    homepage:
      '<a href="http://hangang.seoul.go.kr" target="_blank" class="web">hangang.seoul.go.kr</a> (Korean only)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/81/2616881_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/81/2616881_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '15',
    cat1: 'A02',
    cat2: 'A0205',
    cat3: 'A02050300',
    addr1: '40, Sinbanpo-ro 11-gil, Seocho-gu, Seoul',
    addr2: '',
    zipcode: '06500',
    mapx: '126.9926825046',
    mapy: '37.5076780054',
    mlevel: '6',
    overview:
      'Banpo Bridge Rainbow Fountain is installed along 570 meters on both sides of Banpodaegyo Bridge, with 380 nozzles spraying water from the river below out into a beautiful show of water, music, and lights. The fountain is programmed to play different shows during the day and night. During the day, the fountain shows a hundred different configurations meant to evoke waving willow branches and willow leaves. When the sun goes down, 200 lights illuminate the fountain as it sends out dancing, rainbow-colored jets of water in the air in synchronization with music. <br><br>\n\nBanpo Bridge Rainbow Fountain operates every day from April to October, four to six times a day for 20 minutes. The park also includes an outdoor stage, ecological observing site, and picnic areas.'
  },
  {
    contentid: '1352705',
    contenttypeid: '76',
    title: 'Aqua Planet 63 (아쿠아플라넷 63)',
    createdtime: '20110806002947',
    modifiedtime: '20200210181129',
    tel: '+82-2-780-6382',
    telname: '',
    homepage:
      '<a href="http://www.aquaplanet.co.kr/63/index.jsp" target="_blank">www.aquaplanet.co.kr</a> (Korean, English)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/77/1907677_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/77/1907677_image2_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '20',
    cat1: 'A01',
    cat2: 'A0101',
    cat3: 'A01010500',
    addr1: '50, 63-ro, Yeongdeungpo-gu, Seoul',
    addr2: '',
    zipcode: '07345',
    mapx: '126.9399203060',
    mapy: '37.5196423374',
    mlevel: '6',
    overview:
      'Aqua Planet 63 located in 63 Square was opened on July 1, 2016. The aquarium houses Otter Planet; Aqua Garden featuring waterplants, Amazonian plants, and lungfish; Golden Miracle Zone decorated with bright sunflowers; Penguin Planet; Seal Planet; Coral Planet, colorful with various underwater coral plants; and more zones for an exciting space. In the main aquarium, visitors can watch the fantastic mermaid show, set to music and lights.'
  },
  {
    contentid: '2553836',
    contenttypeid: '76',
    title: 'Bank of Korea Money Museum (한국은행 화폐박물관)',
    createdtime: '20180717011338',
    modifiedtime: '20181025001530',
    tel: '',
    telname: '',
    homepage:
      '<a href="http://museum.bok.or.kr/index.do" target="_blank" title="새창: 한국은행 화폐박물관 홈페이지로 이동">museum.bok.or.kr</a> (Korean, English)',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/55/1570555_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/55/1570555_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0204',
    cat3: 'A02040800',
    addr1: '39, Namdaemun-ro, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04531',
    mapx: '126.9805348496',
    mapy: '37.5621131302',
    mlevel: '6',
    overview:
      'The Bank of Korea Money Museum introduces the history of the currency culture home and abroad through the history and documents related to the Bank of Korea. The museum is not just a cultural space, but also a great place for hands-on education. Exhibitions explain the minting process and the recognition of counterfeits as well as displaying systematic research documents on money and the state economy.'
  },
  {
    contentid: '2482058',
    contenttypeid: '76',
    title: 'Hapjeong-dong Café Street (합정동 카페거리)',
    createdtime: '20170222183320',
    modifiedtime: '20170222183320',
    tel: '',
    telname: '',
    homepage: '',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/34/2014834_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/34/2014834_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '13',
    cat1: 'A02',
    cat2: 'A0204',
    cat3: 'A02040800',
    addr1: 'Areas of Hapjeong-dong & Seogyo-dong, Mapo-gu, Seoul',
    addr2: '',
    zipcode: '',
    mapx: '0',
    mapy: '0',
    mlevel: '',
    overview:
      'Hapjeong-dong Café Street is lined with charming and pretty cafés, creating a peaceful environment. The cafés are almost all individually owned, with each shop giving off its own unique aura, following the style of the owner. Enjoy the delicious desserts and well prepared coffees at the café of your choosing.'
  },
  {
    contentid: '264312',
    contenttypeid: '76',
    title: 'Myeong-dong (명동)',
    createdtime: '20110224204307',
    modifiedtime: '20221213113459',
    tel: '+82-2-778-0333',
    telname: '',
    homepage:
      '<a href="http://www.junggu.seoul.kr/tour/content.do?cmsid=14818&sf_category1=CWS1325&mode=view&page=&cid=98087638" target="_blank" class="web">tour.junggu.seoul.kr</a>',
    firstimage: '',
    firstimage2: '',
    cpyrhtDivCd: '',
    areacode: '1',
    sigungucode: '24',
    cat1: 'A02',
    cat2: 'A0203',
    cat3: 'A02030400',
    addr1: '66, Eulji-ro, Jung-gu, Seoul',
    addr2: '',
    zipcode: '04538',
    mapx: '126.9850038013',
    mapy: '37.5651434137',
    mlevel: '6',
    overview:
      'Myeong-dong is one of the primary shopping districts in Seoul. The two main streets meet in the center of the block with one beginning from Myeong-dong Subway Station (Seoul Subway Line No. 4) and the other from Lotte Department Store at Euljiro. Many brand name shops and department stores line the streets and alleys. Common products for sale include clothes, shoes, and accessories. Unlike Namdaemun or Dongdaemun, many designer brands are sold in Myeong-dong. In addition, several major department stores have branches here, including Lotte Department Store, Shinsegae Department Store, Myeong-dong Migliore, Noon Square and M Plaza. The department stores carry many premium labels and other fashionable goods at reasonable prices. <br><br>\n\nMyeong-dong also has family restaurants, fast food, plus Korean, Western and Japanese dining options. Many restaurants in Myeong-dong specialize in <em>dongaseu</em> (pork cutlet) and <em>kalguksu</em> (noodle soup). Other businesses in the area include hair salons, banks and theaters.'
  },
  {
    contentid: '2484384',
    contenttypeid: '76',
    title: 'Yeonnam-dong (연남동)',
    createdtime: '20170309014211',
    modifiedtime: '20170309015426',
    tel: '',
    telname: '',
    homepage: '',
    firstimage:
      'http://tong.visitkorea.or.kr/cms/resource/13/2484013_image2_1.jpg',
    firstimage2:
      'http://tong.visitkorea.or.kr/cms/resource/13/2484013_image3_1.jpg',
    cpyrhtDivCd: 'Type3',
    areacode: '1',
    sigungucode: '13',
    cat1: 'A02',
    cat2: 'A0204',
    cat3: 'A02040800',
    addr1: '11, Donggyo-ro 39-gil, Mapo-gu, Seoul',
    addr2: '',
    zipcode: '03984',
    mapx: '126.9236317158',
    mapy: '37.5616621632',
    mlevel: '',
    overview:
      'Originally a normal neighborhood just like any other, Yeonnam-dong recently saw an increase in the number of young artists and designers who call this place home. One by one, the streets began to fill up with unique shops, drawing in more and more visitors with each passing day.'
  }
];
